export const createAppStyles = (theme) => ({
  appContainer: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    backgroundColor: theme.background,
    color: theme.text,
    minHeight: "100vh",
    transition: "background-color 0.3s ease, color 0.3s ease",
  },
  appHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1rem",
    backgroundColor: theme.headerBackground || theme.surface,
    borderBottom: `1px solid ${theme.border}`,
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  },
  tabNavigation: {
    display: "flex",
    gap: "0.5rem",
  },
  tabButton: {
    padding: "0.5rem 1rem",
    border: `1px solid ${theme.border}`,
    borderRadius: "0.25rem",
    backgroundColor: theme.surface,
    color: theme.text,
    cursor: "pointer",
    transition: "all 0.2s",
    fontWeight: "500",
  },
  tabButtonActive: {
    backgroundColor: theme.primary,
    color: theme.surface,
    borderColor: theme.primary,
  },
  tabButtonHover: {
    backgroundColor: theme.background,
    borderColor: theme.primary,
  },
  authSection: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  userInfo: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    position: "relative",
  },
  userAvatar: {
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    border: `2px solid ${theme.primary}`,
  },
  username: {
    fontWeight: "500",
    color: theme.text,
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },
  editButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "2px",
    borderRadius: "3px",
    color: theme.textSecondary,
    transition: "color 0.2s",
  },
  editButtonHover: {
    color: theme.primary,
    backgroundColor: theme.background,
  },
  usernameEditor: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },
  usernameInput: {
    padding: "4px 8px",
    border: `1px solid ${theme.border}`,
    borderRadius: "4px",
    fontSize: "14px",
    width: "120px",
    backgroundColor: theme.surface,
    color: theme.text,
  },
  saveButton: {
    background: theme.success || "#10B981",
    color: "white",
    border: "none",
    borderRadius: "3px",
    padding: "4px 6px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  cancelButton: {
    background: theme.error || "#EF4444",
    color: "white",
    border: "none",
    borderRadius: "3px",
    padding: "4px 6px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  themeButton: {
    padding: "0.5rem",
    backgroundColor: theme.surface,
    border: `1px solid ${theme.border}`,
    borderRadius: "0.25rem",
    cursor: "pointer",
    transition: "all 0.2s",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  themeButtonHover: {
    backgroundColor: theme.background,
    borderColor: theme.primary,
  },
  tabContent: {
    flex: 1,
    backgroundColor: theme.background,
  },
  homePage: {
    padding: "2rem",
    backgroundColor: theme.background,
  },
  featureGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "1.5rem",
    marginBottom: "2rem",
  },
  featureCard: {
    padding: "1.5rem",
    border: `1px solid ${theme.border}`,
    borderRadius: "0.5rem",
    backgroundColor: theme.cardBackground || theme.surface,
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    color: theme.text,
    cursor: "pointer",
    transition: "all 0.3s ease",
    position: "relative",
  },
  loadingSpinner: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    fontSize: "1.2rem",
    color: theme.textSecondary,
    backgroundColor: theme.background,
  },
});

const createCharacterSheetStyles = (theme) => ({
  container: {
    margin: "0 auto",
    padding: "20px",
    backgroundColor: theme.background,
    minHeight: "100vh",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  headerCard: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    marginBottom: "24px",
    padding: "24px",
    border: `2px solid ${theme.border}`,
  },
  headerFlex: {
    display: "flex",
    alignItems: "flex-start",
    gap: "20px",
    marginBottom: "20px",
  },
  avatar: {
    width: "60px",
    height: "60px",
    backgroundColor: theme.primary + "20",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: `3px solid ${theme.primary}`,
  },
  characterName: {
    fontSize: "28px",
    fontWeight: "bold",
    color: theme.text,
    margin: "0 0 12px 0",
  },
  infoGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "8px",
  },
  infoItem: {
    fontSize: "14px",
    color: theme.text,
  },
  label: {
    fontWeight: "600",
    color: theme.primary,
  },
  combatStats: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "16px",
    marginTop: "20px",
  },
  statCard: {
    backgroundColor: theme.background,
    border: `2px solid ${theme.border}`,
    borderRadius: "12px",
    padding: "16px",
    textAlign: "center",
    transition: "all 0.2s ease",
    cursor: "pointer",
  },
  statCardHoverDefault: {
    backgroundColor: "red",
    border: `2px solid ${theme.border}`,
    borderRadius: "12px",
    padding: "16px",
    textAlign: "center",
    transition: "all 0.2s ease",
    cursor: "pointer",
  },
  statCardRed: {
    borderColor: "#ef4444",
  },
  statCardBlue: {},
  statCardBrown: {
    borderColor: "#755224",
  },
  statCardBrownHover: {
    backgroundColor: `#755224${"10"}`,
    transform: "translateY(-2px)",
    boxShadow: "0 4px 12px rgba(16, 185, 129, 0.2)",
  },
  statValue: {
    fontSize: "24px",
    fontWeight: "bold",
    marginBottom: "4px",
  },
  statValueRed: {
    color: "#ef4444",
  },
  statValueBlue: {
    color: "#3b82f6",
  },
  statValueBrown: {
    color: "#755224",
  },
  statLabel: {
    fontSize: "12px",
    fontWeight: "500",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  statLabelRed: {
    color: "#ef4444",
  },
  statLabelBlue: {
    color: "#3b82f6",
  },
  statLabelBrown: {
    color: "#755224",
  },
  instructionsCard: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    padding: "20px",
    margin: "24px 0",
    border: `2px solid ${theme.border}`,
  },
  instructionsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "12px",
    marginBottom: "16px",
  },
  instructionItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    color: theme.text,
  },
  warning: {
    backgroundColor: "#fef3c7",
    border: "1px solid #f59e0b",
    color: "#92400e",
    padding: "12px",
    borderRadius: "8px",
    fontSize: "14px",
    textAlign: "center",
  },
  errorContainer: {
    textAlign: "center",
    padding: "40px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    margin: "20px",
  },
  loadingContainer: {
    textAlign: "center",
    padding: "40px",
    color: theme.textSecondary,
  },
  sectionCard: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    padding: "16px",
    marginBottom: "16px",
    border: `2px solid ${theme.border}`,
  },
  corruptionDisplay: {
    textAlign: "center",
    marginBottom: "24px",
  },
  corruptionOrb: {
    width: "80px",
    height: "80px",
    background: "linear-gradient(135deg, #7c3aed, #dc2626)",
    borderRadius: "50%",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
    margin: "0 auto 8px",
  },
  corruptionValue: {
    fontSize: "28px",
    fontWeight: "bold",
    color: "#ffffff",
  },
  corruptionLabel: {
    fontSize: "14px",
    color: theme.textSecondary,
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "12px",
  },
  sectionTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: theme.text,
  },
  button: {
    padding: "8px 16px",
    borderRadius: "8px",
    border: "none",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  buttonPrimary: {
    backgroundColor: theme.primary,
    color: "#ffffff",
  },
  buttonSecondary: {
    backgroundColor: theme.textSecondary,
    color: "#ffffff",
  },
  buttonDanger: {
    backgroundColor: "#dc2626",
    color: "#ffffff",
  },
  buttonSuccess: {
    backgroundColor: "#16a34a",
    color: "#ffffff",
  },
  buttonGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "8px",
    justifyContent: "center",
  },
  input: {
    width: "100%",
    padding: "8px 12px",
    borderRadius: "8px",
    border: `1px solid ${theme.border}`,
    fontSize: "14px",
    backgroundColor: theme.surface,
    color: theme.text,
  },
  inputGroup: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
    marginBottom: "8px",
  },
  checkbox: {
    marginRight: "8px",
  },
  activityItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px",
    borderRadius: "6px",
    marginBottom: "4px",
    fontSize: "12px",
  },
  activityGained: {
    backgroundColor: "#fef2f2",
    border: "1px solid #fecaca",
  },
  activitySpent: {
    backgroundColor: "#f3f4f6",
    border: "1px solid #d1d5db",
  },
  statusIndicator: {
    padding: "6px 12px",
    borderRadius: "6px",
    fontSize: "12px",
    fontWeight: "500",
  },
  statusSuccess: {
    backgroundColor: "#dcfce7",
    color: "#166534",
    border: "1px solid #bbf7d0",
  },
  statusWarning: {
    backgroundColor: "#fef3c7",
    color: "#92400e",
    border: "1px solid #fde68a",
  },
  helpText: {
    fontSize: "12px",
    color: theme.textSecondary,
    marginTop: "12px",
  },
  searchContainer: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    padding: "16px",
    margin: "16px 20px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
  },
  searchInputContainer: {
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  searchIcon: {
    position: "absolute",
    left: "12px",
    zIndex: 1,
    color: theme.textSecondary,
  },
  searchInput: {
    width: "100%",
    padding: "12px 12px 12px 44px",
    paddingRight: "44px",
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    fontSize: "16px",
    backgroundColor: theme.background,
    color: theme.text,
    outline: "none",
    transition: "border-color 0.2s ease",
    fontFamily: "inherit",
  },
  searchClearButton: {
    position: "absolute",
    right: "12px",
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "4px",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background-color 0.2s ease",
    color: theme.textSecondary,
  },
  searchResults: {
    marginTop: "12px",
    fontSize: "14px",
    color: theme.textSecondary,
    textAlign: "center",
  },
  searchResultsHint: {
    fontStyle: "italic",
    opacity: 0.8,
  },
  statsContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "16px",
    padding: "12px 20px",
    backgroundColor: theme.surface,
    borderRadius: "8px",
    margin: "16px 20px",
    border: `1px solid ${theme.border}`,
    flexWrap: "wrap",
  },
  statItem: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "14px",
    fontWeight: "500",
    color: theme.text,
  },
  statDot: {
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    flexShrink: 0,
  },
  subjectsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "16px",
    margin: "0 16px",
  },
  noResultsContainer: {
    textAlign: "center",
    padding: "40px 20px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    margin: "20px",
  },
  noResultsIcon: {
    fontSize: "48px",
    marginBottom: "16px",
  },
  noResultsTitle: {
    fontSize: "24px",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "8px",
  },
  noResultsMessage: {
    fontSize: "16px",
    color: theme.textSecondary,
    marginBottom: "24px",
    lineHeight: "1.5",
  },
  searchSuggestions: {
    textAlign: "left",
    maxWidth: "400px",
    margin: "0 auto 24px auto",
    padding: "0",
    listStyle: "none",
  },
  clearSearchButton: {
    backgroundColor: theme.primary,
    color: "white",
    border: "none",
    borderRadius: "8px",
    padding: "12px 24px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },

  searchSection: {
    padding: "16px",
    borderBottom: `1px solid ${theme.border}`,
    backgroundColor: theme.background,
  },
  searchControls: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    marginBottom: "12px",
  },
  filterControls: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  filterIcon: {
    color: theme.textSecondary,
  },
  filterSelect: {
    padding: "8px 12px",
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    backgroundColor: theme.background,
    color: theme.text,
    fontSize: "14px",
    fontFamily: "inherit",
  },
  searchResultsInfo: {
    fontSize: "14px",
    color: theme.textSecondary,
    marginTop: "8px",
  },
});

export const createAbilityScoresStyles = (theme) => ({
  savingThrowButton: {
    padding: "4px 8px",
    fontSize: "10px",
    fontWeight: "500",
    border: `1px solid ${theme === "dark" ? "#333333" : "#d1d5db"}`,
    borderRadius: "4px",
    backgroundColor: theme === "dark" ? "#1a1a1a" : "#f9fafb",
    color: theme === "dark" ? "#ffffff" : "#374151",
    transition: "all 0.2s ease-in-out",
    outline: "none",
    fontFamily: "inherit",
  },

  savingThrowButtonHover: {
    backgroundColor: theme === "dark" ? "#2a2a2a" : "#e5e7eb",
    borderColor: theme === "dark" ? "#444444" : "#9ca3af",
    boxShadow:
      theme === "dark"
        ? "0 2px 8px rgba(0, 0, 0, 0.5)"
        : "0 2px 4px rgba(0, 0, 0, 0.1)",
  },
  abilityCard: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    marginBottom: "24px",
    padding: "20px",
    border: `2px solid ${theme.border}`,
  },
  abilityTitle: {
    fontSize: "20px",
    fontWeight: "bold",
    color: theme.text,
    marginBottom: "16px",
    textAlign: "center",
  },
  abilityGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
    gap: "12px",
  },
  abilityItem: {
    backgroundColor: theme.background,
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    padding: "12px",
    textAlign: "center",
    transition: "all 0.2s ease",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "4px",
  },
  abilityName: {
    fontSize: "14px",
    fontWeight: "700",
    color: theme.textSecondary,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  abilityModifier: {
    fontSize: "16px",
    fontWeight: "bold",
    color: theme.primary,
  },
  abilityScore: {
    fontSize: "20px",
    fontWeight: "bold",
    color: theme.text,
  },
});

export const createSkillsStyles = (theme) => ({
  skillsCard: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    marginBottom: "24px",
    border: `2px solid ${theme.border}`,
    overflow: "hidden",
  },
  skillsTitle: {
    fontSize: "20px",
    fontWeight: "bold",
    color: theme.text,
    margin: "0",
    padding: "20px 20px 0 20px",
    textAlign: "center",
  },
  skillsTable: {
    width: "100%",
    borderCollapse: "collapse",
  },
  skillsHeaderRow: {
    backgroundColor: theme.background,
  },
  skillsHeaderCell: {
    padding: "12px 16px",
    textAlign: "left",
    fontSize: "12px",
    fontWeight: "600",
    color: theme.textSecondary,
    textTransform: "uppercase",
    borderBottom: `2px solid ${theme.border}`,
    cursor: "pointer",
    transition: "all 0.2s ease",
    userSelect: "none",
  },
  skillsHeaderCellLast: {
    padding: "12px 16px",
    textAlign: "center",
    fontSize: "12px",
    fontWeight: "600",
    color: theme.textSecondary,
    textTransform: "uppercase",
    borderBottom: `2px solid ${theme.border}`,
    cursor: "pointer",
    transition: "all 0.2s ease",
    userSelect: "none",
  },
  skillsHeaderCellHover: {
    backgroundColor: theme.primary + "10",
    color: theme.primary,
  },
  skillsHeaderCellActive: {
    backgroundColor: theme.primary + "20",
    color: theme.primary,
  },
  sortableHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "4px",
  },
  skillRow: {
    borderBottom: `1px solid ${theme.border}`,
    transition: "all 0.2s ease",
  },
  skillRowHover: {
    backgroundColor: theme.background,
  },
  skillCell: {
    padding: "12px 16px",
    fontSize: "14px",
    color: theme.text,
  },
  skillCellLast: {
    padding: "12px 16px",
    fontSize: "14px",
    color: theme.text,
    textAlign: "center",
  },
  proficiencyCircle: {
    width: "16px",
    height: "16px",
    borderRadius: "50%",
    border: `2px solid ${theme.textSecondary}`,
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  proficiencyCircleFilled: {
    backgroundColor: theme.text,
    borderColor: theme.text,
  },
  abilityMod: {
    fontSize: "12px",
    color: theme.textSecondary,
    fontWeight: "500",
  },
  skillNameButton: {
    background: "none",
    border: "none",
    color: theme.text,
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    padding: "0",
    textAlign: "left",
    transition: "color 0.2s ease",
  },
  skillNameButtonProficient: {
    fontWeight: "600",
    color: theme.primary,
  },
  skillNameButtonHover: {
    color: theme.primary,
  },
  bonusValue: {
    fontSize: "14px",
    fontWeight: "600",
    color: theme.text,
  },
});

export const createCharacterCreationStyles = (theme) => ({
  container: {
    padding: "20px",

    margin: "0 auto",
    backgroundColor: theme.background,
    minHeight: "100vh",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  header: {
    backgroundColor: theme.surface,
    padding: "25px",
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    marginBottom: "20px",
  },
  title: {
    margin: 0,
    fontSize: "2.5rem",
    color: theme.text,
    textShadow: "2px 2px 4px rgba(0,0,0,0.1)",
  },
  subtitle: {
    fontSize: "18px",
    color: theme.textSecondary,
    fontWeight: "500",
  },
  userAvatarContainer: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginTop: "12px",
  },
  userAvatar: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    border: `2px solid ${theme.primary}`,
  },
  welcomeText: {
    fontSize: "18px",
    color: theme.textSecondary,
    fontWeight: "500",
  },
  authContainer: {
    textAlign: "center",
    padding: "40px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
  },
  authHeader: {
    color: theme.text,
    marginBottom: "16px",
  },
  authText: {
    color: theme.textSecondary,
  },
  errorContainer: {
    backgroundColor: "#fee2e2",
    border: "1px solid #fecaca",
    color: "#dc2626",
    padding: "12px",
    borderRadius: "8px",
    margin: "16px 0",
    fontSize: "14px",
  },
  tabContainer: {
    display: "flex",
    gap: "8px",
    marginBottom: "20px",
    borderBottom: `2px solid ${theme.border}`,
  },
  tab: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "12px 20px",
    backgroundColor: theme.background,
    border: "none",
    borderRadius: "8px 8px 0 0",
    fontSize: "16px",
    fontWeight: "500",
    color: theme.textSecondary,
    cursor: "pointer",
    transition: "all 0.2s ease",
    marginBottom: "-2px",
  },
  activeTab: {
    backgroundColor: theme.surface,
    color: theme.text,
    borderBottom: `2px solid ${theme.primary}`,
  },
  tabContent: {
    backgroundColor: theme.background,
  },
  panel: {
    backgroundColor: theme.surface,
    padding: "25px",
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    fontSize: "24px",
    fontWeight: "bold",
    color: theme.text,
    marginBottom: "20px",
    borderBottom: `2px solid ${theme.border}`,
    paddingBottom: "12px",
  },
  fieldContainer: {
    marginBottom: "20px",
  },
  label: {
    display: "block",
    fontWeight: "bold",
    marginBottom: "5px",
    color: theme.text,
    fontSize: "16px",
  },
  input: {
    width: "100%",
    padding: "10px",
    borderRadius: "6px",
    border: `2px solid ${theme.border}`,
    fontSize: "16px",
    backgroundColor: theme.surface,
    color: theme.text,
    transition: "border-color 0.2s ease",
  },
  select: {
    width: "100%",
    padding: "10px",
    borderRadius: "6px",
    border: `2px solid ${theme.border}`,
    fontSize: "16px",
    backgroundColor: theme.surface,
    color: theme.text,
    transition: "border-color 0.2s ease",
  },
  helpText: {
    fontSize: "14px",
    color: theme.textSecondary,
    marginTop: "8px",
    fontStyle: "italic",
  },
  button: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "10px 16px",
    border: "none",
    borderRadius: "6px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    color: "white",
  },
  saveButton: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "16px 32px",
    border: "none",
    borderRadius: "8px",
    fontSize: "18px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    width: "100%",
    justifyContent: "center",
    marginTop: "20px",
    color: "white",
  },
  newCharacterButton: {
    backgroundColor: theme.success || "#10B981",
    color: "white",
    border: "none",
    padding: "12px 24px",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    transition: "all 0.2s ease",
  },
  createNewButtonInSaved: {
    backgroundColor: theme.primary,
    color: "white",
    border: "none",
    padding: "12px 20px",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    transition: "all 0.2s ease",
  },
  savedCharactersHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  charactersContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))",
    gap: "20px",
  },
  characterHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "12px",
  },
  characterName: {
    fontSize: "20px",
    fontWeight: "bold",
    alignSelf: "center",
    color: theme.text,
    marginBottom: "8px",
  },
  characterInfo: {
    display: "flex",
    justifyContent: "center",
  },
  characterDetails: {
    fontSize: "14px",
    color: theme.text,
    lineHeight: "1.5",
  },
  characterActions: {
    display: "flex",
    gap: "8px",
  },
  heritage: {
    color: theme.primary,
    fontWeight: "500",
    marginBottom: "4px",
  },
  feats: {
    fontSize: "13px",
    color: theme.textSecondary,
    marginTop: "8px",
    paddingTop: "8px",
    borderTop: `1px solid ${theme.border}`,
  },
  skills: {
    fontSize: "13px",
    color: theme.textSecondary,
    marginTop: "8px",
  },
  emptyCharacters: {
    textAlign: "center",
    padding: "40px",
    color: theme.textSecondary,
    fontSize: "18px",
    backgroundColor: theme.background,
    borderRadius: "12px",
    border: `2px dashed ${theme.border}`,
  },
  characterLimitWarning: {
    backgroundColor: "#fef3c7",
    border: "1px solid #f59e0b",
    color: "#92400e",
    padding: "16px",
    borderRadius: "8px",
    textAlign: "center",
    fontSize: "16px",
    fontWeight: "600",
    marginTop: "20px",
  },
  characterLimitWarningText: {
    fontSize: "14px",
    fontWeight: "400",
    marginTop: "8px",
  },

  skillsHeader: {
    fontSize: "20px",
    fontWeight: "bold",
    color: theme.text,
    marginBottom: "8px",
    margin: 0,
  },
  skillsPlaceholder: {
    padding: "20px",
    backgroundColor: theme.background,
    border: `2px dashed ${theme.border}`,
    borderRadius: "8px",
    textAlign: "center",
    color: theme.textSecondary,
    fontSize: "14px",
    fontStyle: "italic",
  },
  skillsContainer: {
    backgroundColor: theme.background,
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    padding: "16px",
  },
  skillsSubheader: {
    fontSize: "16px",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "12px",
    margin: "0 0 12px 0",
  },
  skillsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "12px",
    marginBottom: "12px",
  },
  skillOptionBase: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "12px",
    borderRadius: "8px",
    transition: "all 0.2s ease",
  },
  skillCheckbox: {
    width: "16px",
    height: "16px",
    accentColor: theme.success,
  },
  skillsComplete: {
    backgroundColor: theme.success + "20",
    color: theme.success,
    padding: "12px",
    borderRadius: "6px",
    textAlign: "center",
    fontSize: "14px",
    fontWeight: "600",
    marginTop: "12px",
  },

  level1ChoiceContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "16px",
    marginTop: "12px",
  },
  level1ChoiceLabel: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "16px",
    backgroundColor: theme.background,
    border: `2px solid ${theme.border}`,
    borderRadius: "12px",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  level1ChoiceLabelSelected: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "16px",
    backgroundColor: theme.primary + "20",
    border: `2px solid ${theme.primary}`,
    borderRadius: "12px",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  level1ChoiceRadio: {
    width: "18px",
    height: "18px",
    accentColor: theme.primary,
  },
  level1ChoiceText: {
    fontSize: "16px",
    fontWeight: "600",
    color: theme.text,
  },
  level1ChoiceTextSelected: {
    fontSize: "16px",
    fontWeight: "600",
    color: theme.primary,
  },

  asiChoiceContainer: {
    border: `2px solid ${theme.border}`,
    borderRadius: "12px",
    padding: "20px",
    backgroundColor: theme.surface,
    marginBottom: "20px",
  },
  asiChoiceHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "16px",
    paddingBottom: "12px",
    borderBottom: `1px solid ${theme.border}`,
  },
  asiStatusBadgeComplete: {
    padding: "4px 12px",
    borderRadius: "16px",
    fontSize: "12px",
    fontWeight: "600",
    backgroundColor: `${theme.success}20`,
    color: theme.success,
    border: `1px solid ${theme.success}`,
  },
  asiStatusBadgeIncomplete: {
    padding: "4px 12px",
    borderRadius: "16px",
    fontSize: "12px",
    fontWeight: "600",
    backgroundColor: `${theme.warning}20`,
    color: theme.warning,
    border: `1px solid ${theme.warning}`,
  },
  asiChoiceTypeGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "12px",
    marginBottom: "20px",
  },
  asiChoiceTypeOption: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "16px",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    border: `2px solid`,
  },
  asiChoiceTypeSelected: {
    borderColor: theme.primary,
    backgroundColor: `${theme.primary}10`,
  },
  asiChoiceTypeDefault: {
    borderColor: theme.border,
    backgroundColor: theme.background,
  },
  asiChoiceRadio: {
    width: "18px",
    height: "18px",
    cursor: "pointer",
  },
  asiChoiceTitle: {
    fontSize: "16px",
    fontWeight: "600",
    marginBottom: "4px",
  },
  asiChoiceSubtitle: {
    fontSize: "12px",
    color: theme.textSecondary,
  },
  statusIndicatorComplete: {
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    backgroundColor: theme.success,
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    fontWeight: "bold",
  },
  noSelectionState: {
    border: `2px dashed ${theme.border}`,
    borderRadius: "8px",
    padding: "32px",
    textAlign: "center",
    backgroundColor: theme.background,
  },
  emptyStateSubtitle: {
    fontSize: "14px",
    color: theme.textSecondary,
  },
  completionMessage: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "12px",
    fontSize: "16px",
    fontWeight: "600",
    color: theme.success,
  },
  warningBadge: {
    padding: "4px 8px",
    backgroundColor: `${theme.warning}20`,
    color: theme.warning,
    borderRadius: "6px",
    fontSize: "11px",
    fontWeight: "600",
    textTransform: "uppercase",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },

  featSelectionContainer: {
    background: theme.surface,
    border: `1px solid ${theme.border}`,
    borderRadius: "8px",
    padding: "16px",
    marginTop: "8px",
  },
  featSearchContainer: {
    position: "relative",
    marginBottom: "16px",
  },
  featSearchInput: {
    width: "100%",
    padding: "12px 16px",
    paddingRight: "44px",
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    fontSize: "14px",
    backgroundColor: theme.background,
    color: theme.text,
    outline: "none",
    transition: "all 0.2s ease",
    boxSizing: "border-box",
    fontFamily: "inherit",
  },
  featSearchClearButton: {
    position: "absolute",
    right: "8px",
    top: "50%",
    transform: "translateY(-50%)",
    background: "none",
    border: "none",
    fontSize: "18px",
    color: theme.textSecondary,
    cursor: "pointer",
    padding: "4px 8px",
    borderRadius: "4px",
    transition: "color 0.2s ease",
  },
  featList: {
    maxHeight: "800px",
    overflowY: "auto",
    border: `1px solid ${theme.border}`,
    borderRadius: "6px",
    backgroundColor: theme.background,
  },
  featListItem: {
    borderBottom: `1px solid ${theme.border}`,
    backgroundColor: "transparent",
    transition: "background-color 0.2s ease",
  },
  featListItemSelected: {
    backgroundColor: `${theme.primary}10`,
  },
  featItemContent: {
    display: "flex",
    alignItems: "flex-start",
    padding: "12px 16px",
    gap: "12px",
  },
  featRadioButton: {
    marginTop: "2px",
    width: "16px",
    height: "16px",
    cursor: "pointer",
  },
  featContentArea: {
    flex: 1,
    minWidth: 0,
  },
  featTitle: {
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    flex: 1,
    transition: "color 0.2s ease",
  },
  featTitleSelected: {
    color: theme.primary,
  },
  featTitleDefault: {
    color: theme.text,
  },
  featPreviewDefault: {
    color: theme.textSecondary,
  },
  levelHpGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: "16px",
    alignItems: "end",
    marginBottom: "20px",
  },
  levelContainer: {
    display: "flex",
    flexDirection: "column",
  },
  hpFieldContainer: {
    display: "flex",
    flexDirection: "column",
  },
  hpValueContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "44px",
  },
  hpDisplay: {
    fontSize: "20px",
    fontWeight: "bold",
    color: theme.text,
    textAlign: "center",
    padding: "10px",
    backgroundColor: theme.background,
    border: `2px solid ${theme.border}`,
    borderRadius: "6px",
    minWidth: "60px",
  },
  hpRollDisplay: {
    fontSize: "20px",
    fontWeight: "bold",
    color: "#10B981",
    textAlign: "center",
    padding: "10px",
    backgroundColor: `#10B981${"20"}`,
    border: "2px solid #10B981",
    borderRadius: "6px",
    minWidth: "60px",
  },
  hpManualInput: {
    textAlign: "center",
    fontSize: "18px",
    fontWeight: "bold",
    width: "100%",
    padding: "10px",
    border: `2px solid ${theme.primary}`,
    borderRadius: "6px",
    backgroundColor: theme.surface,
    color: theme.text,
  },
  hpControlsContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    minHeight: "44px",
  },
  hpControlsInline: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    justifyContent: "center",
  },
  hpToggle: {
    position: "relative",
    width: "46px",
    height: "24px",
    borderRadius: "12px",
    border: "2px solid",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  hpToggleKnob: {
    position: "absolute",
    top: "2px",
    width: "18px",
    height: "18px",
    backgroundColor: "white",
    borderRadius: "50%",
    transition: "left 0.3s ease",
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
  },

  magicModifiersGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "16px",
    marginTop: "12px",
  },
  magicModifierItem: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  magicModifierLabel: {
    fontSize: "14px",
    fontWeight: "600",
    color: theme.text,
  },
  magicModifierInput: {
    textAlign: "center",
    fontSize: "16px",
    fontWeight: "bold",
    width: "100%",
    padding: "8px",
    border: `2px solid ${theme.border}`,
    borderRadius: "6px",
    backgroundColor: theme.surface,
    color: theme.text,
    transition: "border-color 0.2s ease",
  },

  editingWarning: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "12px 16px",
    backgroundColor: theme.warning + "10",
    border: `1px solid ${theme.warning}`,
    borderRadius: "8px",
    marginBottom: "24px",
    color: theme.warning,
  },
  lockedFieldHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "8px",
  },
  lockedBadge: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    padding: "2px 8px",
    backgroundColor: theme.error + "20",
    color: theme.error,
    borderRadius: "12px",
    fontSize: "10px",
    fontWeight: "600",
    textTransform: "uppercase",
    marginLeft: "8px",
    width: "80px",
  },
  lockButton: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    padding: "6px 12px",
    border: "none",
    borderRadius: "6px",
    fontSize: "12px",
    fontWeight: "500",
    color: "white",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  lockedFieldInfo: {
    fontSize: "12px",
    color: theme.textSecondary,
    fontStyle: "italic",
    marginBottom: "12px",
    padding: "8px 12px",
    backgroundColor: theme.background,
    borderRadius: "6px",
    border: `1px solid ${theme.border}`,
    fontWeight: 400,
  },
  lockedAbilityScores: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
    gap: "12px",
    padding: "16px",
    backgroundColor: theme.background,
    borderRadius: "8px",
    border: `1px solid ${theme.border}`,
  },
  lockedAbilityScore: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 12px",
    backgroundColor: theme.surface,
    borderRadius: "6px",
  },
  abilityName: {
    fontSize: "13px",
    color: theme.textSecondary,
    fontWeight: "500",
  },
  abilityValue: {
    fontSize: "16px",
    color: theme.text,
    fontWeight: "600",
  },
  actionButtons: {
    display: "flex",
    gap: "12px",
    justifyContent: "flex-end",
    marginTop: "32px",
    paddingTop: "24px",
    borderTop: `1px solid ${theme.border}`,
  },
  warningContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "12px 16px",
    backgroundColor: theme.warning + "10",
    border: `1px solid ${theme.warning}`,
    borderRadius: "8px",
    marginBottom: "16px",
    color: theme.warning,
    fontSize: "14px",
  },

  featFilterContainer: {
    position: "relative",
    marginBottom: "16px",
  },
  featFilterInput: {
    width: "100%",
    padding: "12px 40px 12px 16px",
    borderRadius: "8px",
    border: `2px solid ${theme.warning || "#F59E0B"}`,
    fontSize: "16px",
    backgroundColor: theme.surface,
    color: theme.text,
    boxShadow:
      "inset 0 2px 6px rgba(245,158,11,0.2), 0 2px 4px rgba(0,0,0,0.1)",
    transition: "all 0.3s ease",
  },
  featFilterClearButton: {
    position: "absolute",
    right: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    backgroundColor: "#FBBF24",
    color: "white",
    border: "none",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
    transition: "all 0.2s ease",
  },
  featFilterResults: {
    fontSize: "12px",
    color: theme.textSecondary,
    marginTop: "4px",
    fontStyle: "italic",
  },
  featContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    maxHeight: "800px",
    overflowY: "auto",
    padding: "4px",
  },
  featItem: {
    backgroundColor: theme.background,
    border: `2px solid ${theme.border}`,
    borderRadius: "12px",
    padding: "16px",
    transition: "all 0.2s ease",
  },
  featItemSelected: {
    backgroundColor: "#F0FDF4",
    border: "2px solid #10B981",
  },
  featHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "8px",
  },
  featLabel: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "600",
  },
  featName: {
    color: theme.text,
  },
  featNameSelected: {
    color: "#059669",
  },
  featCheckbox: {
    width: "16px",
    height: "16px",
    marginRight: "8px",
    accentColor: theme.primary,
  },
  featExpandButton: {
    backgroundColor: theme.background,
    border: `1px solid ${theme.border}`,
    borderRadius: "4px",
    padding: "4px 8px",
    cursor: "pointer",
    fontSize: "12px",
    color: theme.textSecondary,
    transition: "all 0.2s ease",
  },
  featPreview: {
    fontSize: "14px",
    color: theme.textSecondary,
    lineHeight: "1.4",
    fontStyle: "italic",
  },
  featPreviewSelected: {
    fontSize: "14px",
    color: "#047857",
    lineHeight: "1.4",
    fontStyle: "italic",
  },
  featDescription: {
    marginTop: "12px",
    fontSize: "14px",
    color: theme.text,
    lineHeight: "1.5",
    backgroundColor: theme.surface,
    padding: "12px",
    borderRadius: "8px",
    border: `1px solid ${theme.border}`,
  },
  featDescriptionSelected: {
    marginTop: "12px",
    fontSize: "14px",
    color: theme.text,
    lineHeight: "1.5",
    padding: "12px",
    backgroundColor: theme.surface,
    borderRadius: "8px",
    border: `1px solid ${theme.primary}`,
    boxShadow: `0 0 0 1px ${theme.primary}20`,
  },

  levelUpWizard: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  wizardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "20px 24px",
    borderBottom: `1px solid ${theme.border}`,
    backgroundColor: theme.surface,
  },
  wizardTitle: {
    flex: 1,
    textAlign: "center",
  },
  stepIndicator: {
    fontSize: "14px",
    color: theme.textSecondary,
    fontWeight: "500",
  },
  wizardProgress: {
    display: "flex",
    justifyContent: "center",
    gap: "8px",
    padding: "16px",
    backgroundColor: theme.background,
    borderBottom: `1px solid ${theme.border}`,
  },
  progressStep: {
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "14px",
    fontWeight: "600",
    backgroundColor: theme.border,
    color: theme.textSecondary,
    transition: "all 0.2s ease",
  },
  progressStepActive: {
    backgroundColor: theme.primary,
    color: "white",
  },
  progressStepComplete: {
    backgroundColor: theme.success,
    color: "white",
  },
  wizardContent: {
    flex: 1,
    padding: "24px",
    overflowY: "auto",
    backgroundColor: theme.background,
  },
  levelUpStep: {
    maxWidth: "600px",
    margin: "0 auto",
  },
  stepHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "20px",
  },
  stepTitle: {
    margin: 0,
    fontSize: "24px",
    fontWeight: "600",
    color: theme.text,
  },
  stepContent: {
    fontSize: "16px",
    lineHeight: "1.6",
  },
  stepDescription: {
    color: theme.textSecondary,
    marginBottom: "24px",
  },
  hpChoiceContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "16px",
    marginBottom: "24px",
  },
  hpChoice: {
    padding: "16px",
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    textAlign: "center",
    transition: "all 0.2s ease",
  },
  choiceTitle: {
    margin: "0 0 8px 0",
    fontSize: "18px",
    fontWeight: "600",
    color: theme.text,
  },
  choiceDescription: {
    margin: "0 0 16px 0",
    fontSize: "14px",
    color: theme.textSecondary,
  },
  rolledResult: {
    padding: "8px 12px",
    backgroundColor: theme.success + "20",
    color: theme.success,
    borderRadius: "6px",
    marginBottom: "12px",
    fontSize: "14px",
  },
  chosenReward: {
    padding: "16px",
    backgroundColor: theme.primary + "10",
    border: `1px solid ${theme.primary}`,
    borderRadius: "8px",
    color: theme.primary,
    textAlign: "center",
  },
  rewardDetail: {
    fontSize: "14px",
    opacity: 0.8,
  },
  asiContainer: {
    maxWidth: "500px",
    margin: "0 auto",
  },
  asiProgress: {
    textAlign: "center",
    fontSize: "18px",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "24px",
    padding: "12px",
    backgroundColor: theme.surface,
    borderRadius: "8px",
  },
  abilityGrid: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  abilityAsiRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px 16px",
    backgroundColor: theme.surface,
    borderRadius: "8px",
    border: `1px solid ${theme.border}`,
  },
  abilityInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  abilityScoreInfo: {
    fontSize: "14px",
    color: theme.textSecondary,
  },
  abilityControls: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  asiButton: {
    width: "32px",
    height: "32px",
    border: "none",
    borderRadius: "6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: "600",
    color: "white",
    transition: "all 0.2s ease",
  },
  asiIncrement: {
    fontSize: "16px",
    fontWeight: "600",
    color: theme.text,
    minWidth: "24px",
    textAlign: "center",
  },
  levelUpSummary: {
    maxWidth: "500px",
    margin: "0 auto",
  },
  summaryTitle: {
    textAlign: "center",
    fontSize: "20px",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "24px",
  },
  summarySection: {
    marginBottom: "20px",
    padding: "16px",
    backgroundColor: theme.surface,
    borderRadius: "8px",
    border: `1px solid ${theme.border}`,
  },
  sectionTitle: {
    margin: "0 0 8px 0",
    fontSize: "16px",
    fontWeight: "600",
    color: theme.primary,
  },
  wizardActions: {
    display: "flex",
    justifyContent: "space-between",
    padding: "20px 24px",
    borderTop: `1px solid ${theme.border}`,
    backgroundColor: theme.surface,
  },
  subtabContainer: {
    display: "flex",
    gap: "4px",
    borderBottom: `1px solid ${theme.border}`,
    marginBottom: "24px",
    backgroundColor: theme.background,
  },
  subtab: {
    background: "transparent",
    border: "none",
    borderRadius: "8px 8px 0 0",
    padding: "12px 20px",
    fontSize: "14px",
    fontWeight: "500",
    color: theme.textSecondary,
    cursor: "pointer",
    transition: "all 0.2s ease",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    borderBottom: "2px solid transparent",
  },
  activeSubtab: {
    backgroundColor: theme.surface,
    color: theme.text,
    fontWeight: "600",
    borderBottom: `2px solid ${theme.primary}`,
  },
  subtabContent: {
    minHeight: "400px",
  },

  filtersContainer: {
    display: "flex",
    gap: "16px",
    marginBottom: "24px",
    padding: "16px",
    backgroundColor: theme.surface,
    borderRadius: "8px",
    border: `1px solid ${theme.border}`,
    flexWrap: "wrap",
    alignItems: "center",
  },
  searchContainer: {
    flex: "1 1 300px",
    minWidth: "200px",
  },
  searchInput: {
    width: "100%",
    padding: "8px 12px",
    border: `1px solid ${theme.border}`,
    borderRadius: "6px",
    fontSize: "14px",
    backgroundColor: theme.background,
    color: theme.text,
  },
  filterContainer: {
    minWidth: "150px",
  },
  filterSelect: {
    padding: "8px 12px",
    border: `1px solid ${theme.border}`,
    borderRadius: "6px",
    fontSize: "14px",
    backgroundColor: theme.background,
    color: theme.text,
    minWidth: "120px",
  },
  sortContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexWrap: "wrap",
  },
  sortLabel: {
    fontSize: "14px",
    color: theme.textSecondary,
    fontWeight: "500",
  },
  sortButton: {
    padding: "6px 12px",
    border: `1px solid ${theme.border}`,
    borderRadius: "4px",
    fontSize: "12px",
    backgroundColor: theme.background,
    color: theme.textSecondary,
    cursor: "pointer",
    transition: "all 0.2s ease",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  sortButtonActive: {
    backgroundColor: theme.primary,
    color: "white",
    borderColor: theme.primary,
  },

  charactersGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))",
    gap: "20px",
    marginBottom: "24px",
  },
  characterCard: {
    backgroundColor: theme.surface,
    border: `2px solid ${theme.border}`,
    borderRadius: "12px",
    padding: "20px",
    transition: "all 0.2s ease",
  },
  characterCardSelected: {
    borderColor: theme.primary,
    boxShadow: `0 0 0 2px ${theme.primary}20`,
  },
  characterCardHeader: {
    marginBottom: "16px",
  },
  characterCardTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "8px",
  },
  characterNameSection: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flex: 1,
  },
  characterCardName: {
    margin: 0,
    fontSize: "18px",
    fontWeight: "600",
    color: theme.text,
  },
  selectedBadge: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    padding: "2px 8px",
    backgroundColor: theme.primary,
    color: "white",
    borderRadius: "12px",
    fontSize: "10px",
    fontWeight: "600",
    textTransform: "uppercase",
  },
  characterLevel: {
    fontSize: "14px",
    color: theme.textSecondary,
    fontWeight: "500",
    padding: "4px 8px",
    backgroundColor: theme.background,
    borderRadius: "6px",
  },
  characterCardBody: {
    marginBottom: "16px",
  },
  characterInfoRow: {
    display: "flex",
    gap: "12px",
    marginBottom: "8px",
    flexWrap: "wrap",
  },
  characterInfoItem: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "14px",
    color: theme.textSecondary,
  },
  characterStats: {
    display: "flex",
    gap: "8px",
    marginTop: "12px",
    flexWrap: "wrap",
  },
  statBadge: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    padding: "4px 8px",
    backgroundColor: theme.background,
    borderRadius: "6px",
    fontSize: "12px",
  },
  statLabel: {
    color: theme.textSecondary,
    fontWeight: "500",
  },
  statValue: {
    color: theme.text,
    fontWeight: "600",
  },
  heritageBadge: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    padding: "4px 8px",
    backgroundColor: theme.warning + "20",
    color: theme.warning,
    borderRadius: "6px",
    fontSize: "12px",
    fontWeight: "500",
  },
  featsBadge: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    padding: "4px 8px",
    backgroundColor: theme.secondary + "20",
    color: theme.secondary,
    borderRadius: "6px",
    fontSize: "12px",
    fontWeight: "500",
  },
  subclassInfo: {
    marginTop: "8px",
    fontSize: "13px",
  },
  subclassLabel: {
    color: theme.textSecondary,
    marginRight: "6px",
  },
  subclassValue: {
    color: theme.text,
    fontWeight: "500",
  },
  characterCardActions: {
    display: "flex",
    gap: "4px",
    justifyContent: "space-evenly",
  },
  actionButton: {
    alignItems: "center",
    margin: "4px",
    display: "flex",
    justifyContent: "space-around",
    gap: "4px",
    padding: "8px 12px",
    border: "none",
    borderRadius: "6px",
    fontSize: "12px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s ease",
    width: "100px",
  },
  editButton: {
    backgroundColor: theme.primary,
    color: "white",
  },
  levelUpButton: {
    backgroundColor: theme.success,
    color: "white",
  },
  deleteButton: {
    backgroundColor: theme.error,
    color: "white",
    display: "flex",
  },

  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "60px 20px",
    textAlign: "center",
  },
  emptyStateTitle: {
    margin: "16px 0 8px 0",
    fontSize: "20px",
    fontWeight: "600",
    color: theme.text,
  },
  emptyStateText: {
    margin: 0,
    fontSize: "14px",
    color: theme.textSecondary,
    maxWidth: "400px",
  },

  summaryContainer: {
    padding: "16px",
    backgroundColor: theme.surface,
    borderRadius: "8px",
    border: `1px solid ${theme.border}`,
    marginTop: "24px",
  },
  summaryStats: {
    display: "flex",
    gap: "24px",
    flexWrap: "wrap",
  },
  summaryItem: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  summaryLabel: {
    fontSize: "12px",
    color: theme.textSecondary,
    fontWeight: "500",
  },
  summaryValue: {
    fontSize: "16px",
    color: theme.text,
    fontWeight: "600",
  },
});

export const createAbilityScorePickerStyles = (theme) => ({
  fieldContainer: {
    marginBottom: "20px",
  },
  abilityScoresHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "12px",
  },
  abilityScoresTitle: {
    fontSize: "20px",
    fontWeight: "bold",
    color: theme.text,
    margin: 0,
  },
  buttonGroup: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  button: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "10px 16px",
    border: "none",
    borderRadius: "6px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    color: "white",
  },
  helpText: {
    fontSize: "14px",
    color: theme.textSecondary,
    marginBottom: "12px",
    fontStyle: "italic",
  },
  availableStats: {
    backgroundColor: theme.background,
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    padding: "16px",
    marginBottom: "16px",
  },
  availableStatsHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "12px",
  },
  availableStatsLabel: {
    fontSize: "14px",
    fontWeight: "600",
    color: theme.text,
  },
  availableStatsTotal: {
    fontSize: "14px",
    fontWeight: "600",
    color: theme.textSecondary,
  },
  completeIndicator: {
    color: theme.success || "#10B981",
    marginLeft: "8px",
  },
  statsContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
  },
  statBadge: {
    backgroundColor: theme.primary + "20",
    color: theme.primary,
    padding: "6px 12px",
    borderRadius: "20px",
    fontSize: "14px",
    fontWeight: "600",
    border: `1px solid ${theme.primary}`,
  },
  allAssignedText: {
    color: theme.success || "#10B981",
    fontWeight: "600",
    fontSize: "14px",
  },
  abilityGrid: {
    marginTop: "12px",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
    gap: "16px",
  },
  abilityCard: {
    backgroundColor: theme.surface,
    border: `2px solid ${theme.border}`,
    borderRadius: "12px",
    padding: "16px",
    textAlign: "center",
    transition: "all 0.2s ease",
  },
  abilityName: {
    fontSize: "14px",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "8px",
    textTransform: "capitalize",
  },
  abilityModifier: {
    fontSize: "18px",
    fontWeight: "bold",
    color: theme.primary,
    marginBottom: "8px",
  },
  abilityModifierEmpty: {
    fontSize: "18px",
    fontWeight: "bold",
    color: theme.textSecondary,
    marginBottom: "8px",
  },
  abilityScoreContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
  },
  abilityScore: {
    fontSize: "24px",
    fontWeight: "bold",
    color: theme.text,
  },
  input: {
    textAlign: "center",
    fontSize: "18px",
    fontWeight: "bold",
    width: "60px",
    padding: "4px",
    border: `2px solid ${theme.border}`,
    borderRadius: "6px",
    backgroundColor: theme.surface,
    color: theme.text,
  },
  assignSelect: {
    padding: "8px 12px",
    border: `2px solid ${theme.border}`,
    borderRadius: "6px",
    backgroundColor: theme.surface,
    color: theme.text,
    fontSize: "14px",
    width: "100%",
  },
  trashButton: {
    backgroundColor: "#ef4444",
    color: "white",
    border: "none",
    borderRadius: "4px",
    padding: "4px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.2s ease",
  },
});

export const createSpellBookStyles = (theme) => ({
  searchInputContainer: {
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  searchIcon: {
    position: "absolute",
    left: "12px",
    zIndex: 1,
    color: theme.textSecondary,
  },
  searchInput: {
    width: "100%",
    padding: "12px 12px 12px 44px",
    paddingRight: "44px",
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    fontSize: "16px",
    backgroundColor: theme.background,
    color: theme.text,
    outline: "none",
    transition: "border-color 0.2s ease",
    fontFamily: "inherit",
  },
  searchClearButton: {
    position: "absolute",
    right: "12px",
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "4px",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background-color 0.2s ease",
    color: theme.textSecondary,
  },
  searchSection: {
    padding: "16px",
    borderBottom: `1px solid ${theme.border}`,
    backgroundColor: theme.background,
  },
  searchControls: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    marginBottom: "12px",
  },
  filterControls: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  filterIcon: {
    color: theme.textSecondary,
  },
  filterSelect: {
    padding: "8px 12px",
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    backgroundColor: theme.background,
    color: theme.text,
    fontSize: "14px",
    fontFamily: "inherit",
  },
  searchResultsInfo: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  searchResultsText: {
    fontSize: "14px",
    color: theme.textSecondary,
  },
  clearSearchButton: {
    padding: "4px 8px",
    backgroundColor: theme.background,
    color: theme.text,
    border: `1px solid ${theme.border}`,
    borderRadius: "6px",
    fontSize: "12px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    fontFamily: "inherit",
  },
  searchResultsContainer: {
    backgroundColor: theme.surface,
  },
  noResultsContainer: {
    textAlign: "center",
    padding: "40px 20px",
    color: theme.textSecondary,
  },
  noResultsIcon: {
    marginBottom: "16px",
    opacity: 0.5,
  },
  noResultsTitle: {
    fontSize: "20px",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "8px",
    margin: "0 0 8px 0",
  },
  noResultsMessage: {
    fontSize: "16px",
    color: theme.textSecondary,
    marginBottom: "20px",
    lineHeight: "1.5",
    margin: "0 0 20px 0",
  },
  subjectCard: {
    backgroundColor: theme.surface,
    borderRadius: "16px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    border: `2px solid ${theme.border}`,
    overflow: "hidden",
    transition: "all 0.2s ease",
  },
  subjectHeader: {
    padding: "20px",
    borderBottom: `2px solid ${theme.border}`,
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  subjectTitleContainer: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "8px",
  },
  subjectTitle: {
    fontSize: "24px",
    fontWeight: "bold",
    margin: 0,
    color: theme.text,
  },
  subjectDescription: {
    fontSize: "14px",
    color: theme.textSecondary,
    marginBottom: "16px",
    margin: "0 0 16px 0",
  },
  subjectStats: {
    display: "flex",
    gap: "24px",
  },
  subjectStatItem: {
    textAlign: "center",
  },
  subjectStatNumber: {
    display: "block",
    fontSize: "24px",
    fontWeight: "bold",
  },
  subjectStatLabel: {
    display: "block",
    fontSize: "12px",
    color: theme.textSecondary,
    textTransform: "uppercase",
    marginTop: "4px",
  },
  subjectContent: {
    backgroundColor: theme.background,
  },

  sectionContainer: {
    margin: "0",
  },
  sectionButton: {
    width: "100%",
    padding: "16px 20px",
    border: `2px solid transparent`,
    borderRadius: "0",
    cursor: "pointer",
    transition: "all 0.2s ease",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "16px",
    fontWeight: "600",
    fontFamily: "inherit",
  },
  sectionLeft: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  sectionRight: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  sectionProgressText: {
    fontSize: "14px",
    fontWeight: "500",
  },
  sectionProgress: {
    width: "100px",
    height: "6px",
    backgroundColor: "rgba(255, 255, 255, 0.3)",
    borderRadius: "3px",
    overflow: "hidden",
  },
  sectionProgressFill: {
    height: "100%",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    borderRadius: "3px",
    transition: "width 0.3s ease",
  },
  table: {
    width: "100%",
    backgroundColor: theme.surface,
    borderCollapse: "collapse",
  },
  tableHeader: {
    backgroundColor: theme.background,
  },
  tableHeaderCell: {
    padding: "12px 16px",
    textAlign: "left",
    fontSize: "12px",
    fontWeight: "600",
    color: theme.textSecondary,
    textTransform: "uppercase",
    borderBottom: `2px solid ${theme.border}`,
  },
  tableHeaderCellCenter: {
    padding: "12px 16px",
    textAlign: "center",
    fontSize: "12px",
    fontWeight: "600",
    color: theme.textSecondary,
    textTransform: "uppercase",
    borderBottom: `2px solid ${theme.border}`,
  },
  tableRow: {
    borderBottom: `1px solid ${theme.border}`,
    transition: "all 0.2s ease",
  },
  tableRowMastered: {
    backgroundColor: (theme.success || "#10b981") + "10",
  },
  tableRowAttempted: {
    backgroundColor: theme.background,
  },
  tableCell: {
    padding: "12px 16px",
    fontSize: "14px",
    color: theme.text,
    verticalAlign: "top",
  },
  tableCellMenu: {
    padding: "12px 16px",
    fontSize: "14px",
    color: theme.text,
    textAlign: "center",
    position: "relative",
  },
  spellNameContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  spellNameRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  spellName: {
    fontSize: "14px",
    fontWeight: "500",
    color: theme.text,
  },
  spellNameMastered: {
    fontSize: "14px",
    fontWeight: "600",
    color: theme.success || "#059669",
  },
  levelBadge: {
    fontSize: "12px",
    padding: "2px 6px",
    backgroundColor: theme.background,
    color: theme.text,
    borderRadius: "4px",
    fontWeight: "500",
  },
  descriptionToggleButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "2px",
    display: "flex",
    alignItems: "center",
    color: theme.textSecondary,
  },

  criticalMasteredBadge: {
    fontSize: "10px",
    fontWeight: "600",
    padding: "2px 6px",
    borderRadius: "10px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    alignSelf: "flex-start",
    backgroundColor: theme.warning || "#fbbf24",
    color: theme.surface,
    border: "none",
  },
  masteredBadge: {
    fontSize: "10px",
    fontWeight: "600",
    padding: "2px 6px",
    borderRadius: "10px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    alignSelf: "flex-start",
    backgroundColor: theme.success || "#10b981",
    color: "white",
    border: "none",
  },
  attemptedBadge: {
    fontSize: "10px",
    fontWeight: "600",
    padding: "2px 6px",
    borderRadius: "10px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    alignSelf: "flex-start",
    backgroundColor: "white",
    color: theme.success || "#10b981",
    border: `2px solid ${theme.success || "#10b981"}`,
  },

  attemptsContainer: {
    display: "flex",
    gap: "12px",
  },
  checkboxLabel: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    fontSize: "12px",
    color: theme.textSecondary,
  },
  checkboxFirst: {
    width: "16px",
    height: "16px",
    accentColor: theme.primary || "#3b82f6",
    cursor: "not-allowed",
    opacity: 0.8,
  },
  checkboxSecond: {
    width: "16px",
    height: "16px",
    accentColor: theme.success || "#10b981",
    cursor: "not-allowed",
    opacity: 0.8,
  },
  checkboxText: {
    fontSize: "12px",
    fontWeight: "500",
  },

  criticalSuccessContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "4px",
  },
  criticalSuccessText: {
    fontSize: "12px",
    color: theme.warning || "#ffd700",
    fontWeight: "bold",
  },
  noCriticalText: {
    color: theme.textSecondary,
  },

  attemptButton: {
    backgroundColor: theme.primary || "#3b82f6",
    color: "white",
    border: "none",
    borderRadius: "6px",
    padding: "6px 12px",
    fontSize: "12px",
    fontWeight: "500",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    transition: "all 0.2s ease",
    fontFamily: "inherit",
  },
  attemptButtonDisabled: {
    backgroundColor: theme.textSecondary,
    cursor: "not-allowed",
  },
  menuButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "4px",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.textSecondary,
  },

  dropdownMenu: {
    position: "absolute",
    right: "0",
    top: "100%",
    backgroundColor: theme.surface,
    border: `1px solid ${theme.border}`,
    borderRadius: "8px",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
    zIndex: 1000,
    minWidth: "160px",
    padding: "4px",
  },
  dropdownMenuItem: {
    width: "100%",
    padding: "8px 12px",
    border: "none",
    background: "none",
    cursor: "pointer",
    textAlign: "left",
    borderRadius: "4px",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: theme.text,
    fontFamily: "inherit",
    transition: "background-color 0.2s ease",
  },

  modalOverlay: {
    position: "fixed",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2000,
  },
  modalContent: {
    backgroundColor: theme.surface,
    padding: "24px",
    borderRadius: "12px",
    boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1)",
    minWidth: "400px",
    maxWidth: "500px",
  },
  modalTitle: {
    margin: "0 0 8px 0",
    fontSize: "18px",
    fontWeight: "600",
    color: theme.text,
  },
  modalSubtitle: {
    margin: "0 0 16px 0",
    fontSize: "14px",
    color: theme.textSecondary,
  },
  descriptionRowCell: {
    padding: "0",
    border: "none",
  },
  descriptionContainer: {
    margin: "0 16px 12px 16px",
    padding: "16px",
    backgroundColor: theme.background,
    border: `1px solid ${theme.border}`,
    borderRadius: "8px",
    fontSize: "14px",
    lineHeight: "1.5",
  },
  descriptionTitle: {
    fontWeight: "600",
    color: theme.primary || "#60a5fa",
    marginBottom: "8px",
    fontSize: "16px",
  },
  descriptionMeta: {
    fontStyle: "italic",
    color: theme.textSecondary,
    marginBottom: "12px",
    fontSize: "13px",
  },
  descriptionText: {
    whiteSpace: "pre-line",
    color: theme.text,
    marginBottom: "12px",
    margin: "0 0 12px 0",
  },
  descriptionHigherLevels: {
    marginBottom: "12px",
    fontStyle: "italic",
    color: theme.textSecondary,
    margin: "0 0 12px 0",
  },
  descriptionTags: {
    display: "flex",
    flexWrap: "wrap",
    gap: "6px",
  },
  descriptionTag: {
    display: "inline-block",
    padding: "4px 8px",
    backgroundColor: theme.background,
    color: theme.text,
    fontSize: "12px",
    borderRadius: "4px",
    fontWeight: "500",
    border: `1px solid ${theme.border}`,
  },

  searchResultsHint: {
    color: theme.textSecondary,
    opacity: 0.8,
  },
  searchResults: {
    fontSize: "14px",
    color: theme.textSecondary,
    fontStyle: "italic",
  },
  searchSuggestions: {
    textAlign: "left",
    display: "inline-block",
    margin: "0 0 24px 0",
    padding: "0",
    listStyle: "none",
  },
  searchContainer: {
    margin: "0 20px 24px 20px",
    padding: "20px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  },
  statsContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "24px",
    margin: "0 20px 24px 20px",
    padding: "16px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    flexWrap: "wrap",
  },
  statItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    fontWeight: "500",
    color: theme.text,
  },
  statDot: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
  },
  subjectsGrid: {
    display: "grid",
    gap: "20px",
    margin: "0 20px",
  },

  researchButton: {
    backgroundColor: theme.warning || "#f59e0b",
    color: "white",
    border: "none",
    borderRadius: "6px",
    padding: "6px 12px",
    fontSize: "12px",
    fontWeight: "500",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    transition: "all 0.2s ease",
    fontFamily: "inherit",
  },

  researchButtonDisabled: {
    backgroundColor: theme.textSecondary,
    cursor: "not-allowed",
  },

  failedBadge: {
    fontSize: "10px",
    fontWeight: "600",
    padding: "2px 6px",
    borderRadius: "10px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    backgroundColor: theme.error || "#ef4444",
    color: "white",
  },

  researchedBadge: {
    fontSize: "10px",
    fontWeight: "600",
    padding: "2px 6px",
    borderRadius: "10px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    backgroundColor: theme.warning || "#f59e0b",
    color: "white",
  },
  tableRowResearched: {
    backgroundColor: (theme.warning || "#f59e0b") + "10",
    borderLeft: `3px solid ${theme.warning || "#f59e0b"}`,
  },
  tableRowFailed: {
    backgroundColor: (theme.error || "#ef4444") + "05",
    borderLeft: `3px solid ${theme.error || "#ef4444"}`,
  },
  modalField: {
    marginBottom: "16px",
  },
  modalLabel: {
    display: "block",
    marginBottom: "8px",
    fontSize: "14px",
    fontWeight: "500",
    color: theme.text,
  },
  modalInput: {
    width: "100%",
    padding: "8px 12px",
    border: `2px solid ${theme.border}`,
    borderRadius: "6px",
    fontSize: "14px",
    backgroundColor: theme.surface,
    color: theme.text,
    fontFamily: "inherit",
    boxSizing: "border-box",
  },
  modalInputDisabled: {
    backgroundColor: theme.background,
    cursor: "not-allowed",
  },
  modalCheckboxLabel: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    cursor: "pointer",
    color: theme.text,
  },

  modalCheckbox: {
    width: "16px",
    height: "16px",
  },

  modalCheckboxText: {
    fontSize: "14px",
    fontWeight: "500",
  },

  modalHelpText: {
    fontSize: "12px",
    color: theme.textSecondary,
    marginTop: "4px",
  },

  modalActions: {
    display: "flex",
    gap: "12px",
    justifyContent: "flex-end",
    marginTop: "24px",
  },

  modalCancelButton: {
    padding: "8px 16px",
    border: `2px solid ${theme.border}`,
    backgroundColor: theme.surface,
    color: theme.text,
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontFamily: "inherit",
  },

  modalSaveButton: {
    padding: "8px 16px",
    border: `2px solid ${theme.success || "#10b981"}`,
    backgroundColor: theme.success || "#10b981",
    color: "white",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontFamily: "inherit",
  },

  spellStateIndicators: {
    display: "flex",
    gap: "4px",
    flexWrap: "wrap",
    marginTop: "4px",
  },

  dropdownMenuItemResearch: {
    width: "100%",
    padding: "8px 12px",
    border: "none",
    background: "none",
    cursor: "pointer",
    textAlign: "left",
    borderRadius: "4px",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: theme.warning || "#f59e0b",
    fontFamily: "inherit",
    transition: "background-color 0.2s ease",
  },

  searchHighlight: {
    backgroundColor: (theme.warning || "#f59e0b") + "40",
    color: theme.warning || "#f59e0b",
    fontWeight: "bold",
    padding: "1px 2px",
    borderRadius: "2px",
  },
});

export const searchStyles = (theme) => ({
  searchContainer: {
    margin: "0 20px 24px 20px",
    padding: "20px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  },

  searchInputContainer: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    marginBottom: "8px",
  },

  searchIcon: {
    position: "absolute",
    left: "12px",
    zIndex: 1,
    pointerEvents: "none",
  },

  searchInput: {
    width: "100%",
    padding: "12px 12px 12px 44px",
    paddingRight: "44px",
    fontSize: "16px",
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    backgroundColor: theme.background,
    color: theme.text,
    outline: "none",
    transition: "all 0.2s ease",
    fontFamily: "inherit",
  },

  searchClearButton: {
    position: "absolute",
    right: "8px",
    padding: "4px",
    border: "none",
    background: "none",
    cursor: "pointer",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background-color 0.2s ease",
  },

  searchResults: {
    fontSize: "14px",
    color: theme.textSecondary,
    fontStyle: "italic",
  },

  searchResultsHint: {
    color: theme.textSecondary,
    opacity: 0.8,
  },

  noResultsContainer: {
    textAlign: "center",
    padding: "60px 20px",
    margin: "20px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
  },

  noResultsIcon: {
    fontSize: "48px",
    marginBottom: "16px",
    opacity: 0.5,
  },

  noResultsTitle: {
    fontSize: "24px",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "12px",
    margin: "0 0 12px 0",
  },

  noResultsMessage: {
    fontSize: "16px",
    color: theme.textSecondary,
    marginBottom: "20px",
    lineHeight: "1.5",
  },

  searchSuggestions: {
    textAlign: "left",
    display: "inline-block",
    margin: "0 0 24px 0",
    padding: "0",
    listStyle: "none",
  },

  clearSearchButton: {
    padding: "12px 24px",
    backgroundColor: theme.primary,
    color: theme.surface,
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
});

export const createCharacterSelectorStyles = (theme) => {
  const safeTheme = theme || {
    surface: "#ffffff",
    background: "#f8fafc",
    text: "#1f2937",
    textSecondary: "#6b7280",
    primary: "#6366f1",
    secondary: "#8b5cf6",
    success: "#10b981",
    warning: "#f59e0b",
    error: "#ef4444",
    border: "#e5e7eb",
  };

  return {
    container: {
      padding: "20px",
      backgroundColor: safeTheme.surface,
      borderBottom: `2px solid ${safeTheme.border}`,
      marginBottom: "20px",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    },
    innerContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "20px",

      margin: "0 auto",
    },
    selectorRow: {
      display: "flex",
      alignItems: "center",
      gap: "15px",
      flexWrap: "wrap",
    },
    label: {
      fontSize: "16px",
      fontWeight: "600",
      color: safeTheme.text,
    },
    select: {
      padding: "8px 12px",
      fontSize: "16px",
      border: `2px solid ${safeTheme.border}`,
      borderRadius: "8px",
      backgroundColor: safeTheme.surface,
      color: safeTheme.text,
      minWidth: "200px",
    },
    singleCharacterDisplay: {
      padding: "8px 12px",
      fontSize: "16px",
      backgroundColor: safeTheme.primary + "20",
      border: `2px solid ${safeTheme.primary}`,
      borderRadius: "8px",
      color: safeTheme.text,
      fontWeight: "500",
      minWidth: "200px",
      textAlign: "center",
    },
    noCharactersDisplay: {
      padding: "8px 12px",
      fontSize: "16px",
      border: `2px solid ${safeTheme.border}`,
      borderRadius: "8px",
      backgroundColor: safeTheme.background,
      color: safeTheme.textSecondary,
      minWidth: "200px",
      textAlign: "center",
    },
    warningMessage: {
      backgroundColor: (safeTheme.warning || "#F59E0B") + "20",
      color: safeTheme.warning || "#F59E0B",
      border: `1px solid ${safeTheme.warning || "#F59E0B"}`,
      padding: "12px 20px",
      borderRadius: "8px",
      fontSize: "16px",
      fontWeight: "500",
      textAlign: "center",
    },
    errorMessage: {
      backgroundColor: (safeTheme.error || "#EF4444") + "20",
      border: `1px solid ${safeTheme.error || "#EF4444"}`,
      color: safeTheme.error || "#EF4444",
      padding: "12px",
      borderRadius: "8px",
      margin: "16px 0",
      fontSize: "14px",

      marginLeft: "auto",
      marginRight: "auto",
      textAlign: "center",
    },
  };
};

export const createPotionsStyles = (theme) => ({
  container: {
    maxWidth: "1400px",
    margin: "0 auto",
    padding: "20px",
    backgroundColor: theme.background,
    minHeight: "100vh",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  title: {
    fontSize: "32px",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "24px",
    color: theme.text,
    textShadow: "2px 2px 4px rgba(0,0,0,0.1)",
  },
  themeControls: {
    display: "flex",
    gap: "16px",
    justifyContent: "center",
    marginBottom: "24px",
    flexWrap: "wrap",
  },
  themeControlGroup: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  themeLabel: {
    fontSize: "14px",
    fontWeight: "600",
    color: theme.text,
  },
  themeSelect: {
    padding: "8px 12px",
    border: `2px solid ${theme.border}`,
    borderRadius: "6px",
    backgroundColor: theme.surface,
    color: theme.text,
    fontSize: "14px",
  },
  controlsContainer: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "24px",
  },
  card: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    padding: "20px",
    marginBottom: "20px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  thresholdCard: {
    display: "flex",
    fontSize: "14px",
    justifyContent: "space-between",
    color: theme.text,
    backgroundColor: theme.surface,
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",

    borderTop: `2px solid ${theme.border}`,
    marginLeft: "4px",
  },
  thresholdCardTitle: {
    paddingBottom: "6px",
    fontWeight: "semi-bold",
    color: theme.highlight,
    margin: 0,
  },
  cardTitle: {
    fontSize: "20px",
    fontWeight: "bold",
    color: theme.text,
    marginBottom: "16px",
    margin: 0,
  },
  proficiencyGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "20px",
  },
  proficiencySection: {
    backgroundColor: theme.background,
    padding: "16px",
    borderRadius: "8px",
    border: `1px solid ${theme.border}`,
    color: theme.text,
  },
  proficiencyTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "12px",
  },
  inputGroup: {
    marginBottom: "12px",
  },
  inputLabel: {
    display: "block",
    fontSize: "14px",
    fontWeight: "500",
    color: theme.text,
    marginBottom: "4px",
  },
  select: {
    width: "100%",
    padding: "8px 12px",
    border: `2px solid ${theme.border}`,
    borderRadius: "6px",
    backgroundColor: theme.surface,
    color: theme.text,
    fontSize: "14px",
  },
  checkboxGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  checkboxLabel: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    color: theme.text,
    cursor: "pointer",
  },
  maxQualityInfo: {
    marginTop: "12px",
    padding: "8px 12px",
    backgroundColor: theme.primary + "20",
    borderRadius: "6px",
    fontSize: "14px",
    color: theme.text,
    fontWeight: "500",
  },
  searchContainer: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    flexWrap: "wrap",
  },
  searchInputContainer: {
    position: "relative",
    flex: 1,
    minWidth: "200px",
  },
  searchIcon: {
    position: "absolute",
    left: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    color: theme.textSecondary,
  },
  searchInput: {
    width: "100%",
    padding: "10px 12px 10px 40px",
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    backgroundColor: theme.surface,
    color: theme.text,
    fontSize: "16px",
  },
  mainGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "20px",
  },
  potionList: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    maxHeight: "600px",
    overflowY: "auto",
    padding: "4px",
  },
  potionItem: {
    padding: "16px",
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    backgroundColor: theme.background,
  },
  potionItemSelected: {
    borderColor: theme.primary,
    backgroundColor: theme.primary + "10",
  },
  potionItemHover: {
    borderColor: theme.primary + "80",
    backgroundColor: theme.surface,
  },
  potionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "8px",
  },
  potionName: {
    fontSize: "16px",
    fontWeight: "600",
    color: theme.text,
    margin: 0,
  },
  potionMeta: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
  },
  potionYear: {
    fontSize: "12px",
    color: theme.textSecondary,
    fontWeight: "500",
  },
  rarityBadge: {
    fontSize: "10px",
    fontWeight: "600",
    padding: "2px 6px",
    borderRadius: "10px",
    textTransform: "uppercase",
    color: "white",
  },
  rarityColors: {
    common: "#6B7280",
    uncommon: "#10B981",
    rare: "#3B82F6",
    "very rare": "#8B5CF6",
    legendary: "#F59E0B",
  },
  potionDescription: {
    fontSize: "14px",
    color: theme.textSecondary,
    lineHeight: "1.4",
    margin: 0,
  },
  brewingInterface: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  selectedPotionCard: {
    backgroundColor: theme.primary + "10",
    border: `2px solid ${theme.primary}`,
    borderRadius: "12px",
    padding: "20px",
  },
  selectedPotionTitle: {
    fontSize: "20px",
    fontWeight: "bold",
    color: theme.text,
    marginBottom: "8px",
    margin: 0,
  },
  selectedPotionDescription: {
    fontSize: "14px",
    color: theme.textSecondary,
    lineHeight: "1.5",
    margin: 0,
  },
  brewButton: {
    backgroundColor: theme.primary,
    color: "white",
    border: "none",
    borderRadius: "8px",
    padding: "16px 24px",
    fontSize: "18px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "12px",
    transition: "all 0.2s ease",
    width: "100%",
  },
  brewButtonDisabled: {
    backgroundColor: theme.textSecondary,
    cursor: "not-allowed",
  },
  resultCard: {
    backgroundColor: theme.surface,
    border: `2px solid ${theme.border}`,
    borderRadius: "12px",
    padding: "20px",
  },
  resultTitle: {
    fontSize: "18px",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "16px",
    margin: 0,
  },
  resultGrid: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  resultRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  resultLabel: {
    fontSize: "14px",
    fontWeight: "500",
    color: theme.textSecondary,
  },
  resultValue: {
    fontSize: "14px",
    fontWeight: "600",
    color: theme.text,
  },
  diceResult: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  diceValue: {
    fontSize: "14px",
    fontWeight: "600",
    color: theme.text,
  },
  qualityResult: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "14px",
    fontWeight: "600",
    textTransform: "capitalize",
  },
  qualityRuined: {
    color: "#EF4444",
  },
  qualityFlawed: {
    color: "#F59E0B",
  },
  qualityNormal: {
    color: "#10B981",
  },
  qualityExceptional: {
    color: "#3B82F6",
  },
  qualitySuperior: {
    color: "#8B5CF6",
  },
  resultTimestamp: {
    fontSize: "12px",
    color: theme.textSecondary,
    fontStyle: "italic",
    textAlign: "center",
    marginTop: "8px",
  },
  referenceGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "20px",
    marginTop: "24px",
  },
  referenceTable: {
    width: "100%",
    borderCollapse: "collapse",
  },
  referenceTableHeader: {
    display: "grid",
    gridTemplateColumns: "1fr repeat(4, 0.8fr)",
    gap: "8px",
    padding: "12px",
    backgroundColor: theme.background,
    fontWeight: "600",
    fontSize: "14px",
    color: theme.text,
    borderBottom: `2px solid ${theme.border}`,
  },
  referenceTableRow: {
    display: "grid",
    gridTemplateColumns: "1fr repeat(4, 0.8fr)",
    gap: "8px",
    padding: "8px 12px",
    borderBottom: `1px solid ${theme.border}`,
    fontSize: "14px",
    color: theme.text,
  },
  referenceTableRowHeader: {
    fontWeight: "600",
    textTransform: "capitalize",
  },
  ingredientEffectsList: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  ingredientEffectRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 12px",
    backgroundColor: theme.background,
    borderRadius: "6px",
    fontSize: "14px",
  },
  ingredientEffectLabel: {
    fontWeight: "600",
    textTransform: "capitalize",
    color: theme.text,
  },
  ingredientEffectValue: {
    fontWeight: "500",
    color: theme.text,
  },
  ingredientEffectHarder: {
    color: "#EF4444",
  },
  ingredientEffectEasier: {
    color: "#10B981",
  },
  button: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "10px 16px",
    border: "none",
    borderRadius: "6px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    color: "white",
  },
  primaryButton: {
    backgroundColor: theme.primary,
  },
  ingredientTransformation: {
    marginTop: "12px",
    padding: "8px 12px",
    backgroundColor: theme.surface,
    borderRadius: "6px",
    border: `1px solid ${theme.border}`,
  },

  transformationRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "8px",
  },

  rawQuality: {
    fontSize: "14px",
    color: theme.text,
    fontWeight: "500",
  },

  preparedQuality: {
    fontSize: "14px",
    color: theme.text,
    fontWeight: "600",
  },

  dcModifier: {
    fontSize: "12px",
    color: theme.textSecondary,
    fontStyle: "italic",
  },

  rollPreview: {
    marginTop: "16px",
  },

  rollPreviewContent: {},

  totalValue: {
    fontWeight: "700",
    color: theme.primary,
  },

  warningText: {
    marginTop: "8px",
    padding: "8px",
    backgroundColor: theme.warning || "#FEF3C7",
    color: theme.warningText || "#92400E",
    fontSize: "14px",
    borderRadius: "4px",
    textAlign: "center",
  },
});

export const createFeatStyles = (theme) => ({
  fieldContainer: {
    marginBottom: "20px",
  },
  skillsHeader: {
    fontSize: "20px",
    fontWeight: "bold",
    color: theme.text,
    marginBottom: "8px",
    margin: 0,
  },
  featFilterContainer: {
    position: "relative",
    marginBottom: "16px",
  },
  featFilterInput: {
    width: "100%",
    padding: "12px 40px 12px 16px",
    borderRadius: "8px",
    border: `2px solid ${theme.warning || "#F59E0B"}`,
    fontSize: "16px",
    backgroundColor: theme.surface,
    color: theme.text,
    boxShadow:
      "inset 0 2px 6px rgba(245,158,11,0.2), 0 2px 4px rgba(0,0,0,0.1)",
    transition: "all 0.3s ease",
  },
  featFilterClearButton: {
    position: "absolute",
    right: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    backgroundColor: "#FBBF24",
    color: "white",
    border: "none",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
    transition: "all 0.2s ease",
  },
  featFilterResults: {
    fontSize: "12px",
    color: theme.textSecondary,
    marginTop: "4px",
    fontStyle: "italic",
  },
  featsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    maxHeight: "800px",
    overflowY: "auto",
    padding: "4px",
  },
  featHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "8px",
  },
  featLabelClickable: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "600",
  },
  expandButton: {
    backgroundColor: theme.background,
    border: `1px solid ${theme.border}`,
    borderRadius: "4px",
    padding: "4px 8px",
    cursor: "pointer",
    fontSize: "12px",
    color: theme.textSecondary,
    transition: "all 0.2s ease",
  },
  noFeatsFound: {
    textAlign: "center",
    padding: "40px 20px",
    color: theme.textSecondary,
    fontSize: "16px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px dashed ${theme.border}`,
  },
  helpText: {
    fontSize: "14px",
    color: theme.textSecondary,
    marginTop: "12px",
    fontStyle: "italic",
  },

  levelHeader: {
    margin: "0 0 12px 0",
    fontSize: "14px",
    fontWeight: "600",
    color: theme.text,
  },
  levelHeaderSelected: {
    margin: "0 0 12px 0",
    fontSize: "14px",
    fontWeight: "600",
    color: theme.success,
  },
  featureContainer: {
    marginBottom: "16px",
  },
  singleFeature: {
    marginBottom: "12px",
    padding: "12px",
    backgroundColor: theme.surface,
    borderRadius: "6px",
    border: `2px solid ${theme.border}`,
  },
  singleFeatureSelected: {
    marginBottom: "12px",
    padding: "12px",
    backgroundColor: theme.success + "10",
    borderRadius: "6px",
    border: `2px solid ${theme.success}40`,
  },
  choiceContainer: {
    marginBottom: "12px",
    padding: "12px",
    backgroundColor: theme.surface,
    borderRadius: "6px",
    border: `2px solid ${theme.border}`,
    transition: "all 0.2s ease",
  },
  choiceContainerSelected: {
    marginBottom: "12px",
    padding: "12px",
    backgroundColor: theme.success + "10",
    borderRadius: "6px",
    border: `2px solid ${theme.success}`,
    transition: "all 0.2s ease",
  },
  choiceContainerSelectedOption: {
    marginBottom: "12px",
    padding: "12px",
    backgroundColor: theme.success + "20",
    borderRadius: "6px",
    border: `2px solid ${theme.success}`,
    transition: "all 0.2s ease",
  },
  featureName: {
    fontSize: "13px",
    color: theme.primary,
    display: "block",
    marginBottom: "4px",
    fontWeight: "600",
  },
  featureNameSelected: {
    fontSize: "13px",
    color: theme.success,
    display: "block",
    marginBottom: "4px",
    fontWeight: "600",
  },
  featureDescription: {
    margin: 0,
    fontSize: "12px",
    color: theme.text,
    lineHeight: "1.4",
  },
  featureDescriptionSelected: {
    margin: 0,
    fontSize: "12px",
    color: theme.text,
    lineHeight: "1.4",
  },
  choiceLabel: {
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
    cursor: "pointer",
  },
  choiceLabelDisabled: {
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
    cursor: "not-allowed",
  },
  radioButton: {
    marginTop: "2px",
    accentColor: theme.success,
    cursor: "pointer",
    width: "16px",
    height: "16px",
  },
  radioButtonDisabled: {
    marginTop: "2px",
    accentColor: theme.success,
    cursor: "not-allowed",
    width: "16px",
    height: "16px",
  },
  choiceStatus: {
    color: theme.textSecondary,
    fontSize: "12px",
    fontWeight: "normal",
    marginLeft: "8px",
  },
  choiceStatusSelected: {
    fontSize: "12px",
    fontWeight: "normal",
    marginLeft: "8px",
  },
  choiceStatusRequired: {
    color: theme.warning,
    fontSize: "12px",
    fontWeight: "normal",
    marginLeft: "8px",
  },
  choiceInfo: {
    marginBottom: "12px",
    fontSize: "12px",
    color: theme.textSecondary,
    fontStyle: "italic",
  },
  lockedFeature: {
    marginBottom: "12px",
    opacity: 0.6,
  },
  lockedContainer: {
    padding: "8px 12px",
    backgroundColor: theme.surface,
    borderRadius: "4px",
    border: `1px solid ${theme.border}`,
    fontSize: "12px",
    color: theme.textSecondary,
    fontStyle: "italic",
  },
  summary: {
    padding: "12px",
    borderRadius: "6px",
    borderLeft: `4px solid ${theme.primary}`,
  },
  summarySelected: {
    padding: "12px",
    backgroundColor: theme.success + "10",
    borderRadius: "6px",
    borderLeft: `4px solid ${theme.success}`,
  },
  summaryTitle: {
    fontSize: "12px",
    color: theme.primary,
    display: "block",
    marginBottom: "4px",
    fontWeight: "600",
  },
  summaryTitleSelected: {
    fontSize: "12px",
    color: theme.success,
    display: "block",
    marginBottom: "4px",
    fontWeight: "600",
  },
  summaryText: {
    margin: 0,
    fontSize: "12px",
    color: theme.text,
    fontStyle: "italic",
    lineHeight: "1.4",
  },
  warningContainer: {
    fontSize: "14px",
    marginTop: "12px",
    fontStyle: "italic",
    color: theme.warning,
    backgroundColor: theme.warning + "20",
    padding: "8px 12px",
    borderRadius: "4px",
    border: `1px solid ${theme.warning}40`,
  },
  availableChoicesIndicator: {
    fontSize: "12px",
    color: theme.textSecondary,
    marginLeft: "4px",
  },
  featCard: {
    backgroundColor: theme.background,
    border: `2px solid ${theme.border}`,
    borderRadius: "12px",
    padding: "16px",
    transition: "all 0.2s ease",
  },

  featCardSelected: {
    backgroundColor: theme.surface,
    border: `2px solid ${theme.primary}`,
    borderRadius: "12px",
    boxShadow: `0 0 0 1px ${theme.primary}20`,
  },

  featName: {
    color: theme.text,
  },

  featNameSelected: {
    color: theme.primary,
    fontWeight: "600",
  },

  featPreview: {
    fontSize: "14px",
    color: theme.textSecondary,
    lineHeight: "1.4",
    fontStyle: "italic",
  },

  featPreviewSelected: {
    fontSize: "14px",
    color: theme.primary,
    lineHeight: "1.4",
    fontStyle: "italic",
  },

  featDescription: {
    marginTop: "12px",
    fontSize: "14px",
    color: theme.text,
    lineHeight: "1.5",
    padding: "12px",
    backgroundColor: theme.surface,
    borderRadius: "8px",
    border: `1px solid ${theme.border}`,
  },
  featDescriptionSelected: {
    marginTop: "12px",
    fontSize: "14px",
    color: theme.text,
    lineHeight: "1.5",
    padding: "12px",
    backgroundColor: theme.surface,
    borderRadius: "8px",
    border: `1px solid ${theme.primary}`,
    boxShadow: `0 0 0 1px ${theme.primary}20`,
  },
});

export const createBackgroundStyles = (theme) => ({
  fieldContainer: {
    marginBottom: "20px",
  },
  skillsHeader: {
    fontSize: "20px",
    fontWeight: "bold",
    color: theme.text,
    marginBottom: "8px",
    margin: 0,
  },
  featFilterContainer: {
    position: "relative",
    marginBottom: "16px",
  },
  featFilterInput: {
    width: "100%",
    padding: "12px 40px 12px 16px",
    borderRadius: "8px",
    border: `2px solid ${theme.warning || "#F59E0B"}`,
    fontSize: "16px",
    backgroundColor: theme.surface,
    color: theme.text,
    boxShadow:
      "inset 0 2px 6px rgba(245,158,11,0.2), 0 2px 4px rgba(0,0,0,0.1)",
    transition: "all 0.3s ease",
  },
  featFilterClearButton: {
    position: "absolute",
    right: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    backgroundColor: "#FBBF24",
    color: theme.text,
    border: "none",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
    transition: "all 0.2s ease",
  },
  featFilterResults: {
    fontSize: "12px",
    color: theme.text,
    marginTop: "4px",
    fontStyle: "italic",
  },
  featsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    maxHeight: "800px",
    overflowY: "auto",
    padding: "4px",
  },
  featHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "8px",
  },
  featLabelClickable: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "600",
  },
  expandButton: {
    backgroundColor: theme.background,
    border: `1px solid ${theme.border}`,
    borderRadius: "4px",
    padding: "4px 8px",
    cursor: "pointer",
    fontSize: "12px",
    color: theme.text,
    transition: "all 0.2s ease",
  },
  noFeatsFound: {
    textAlign: "center",
    padding: "40px 20px",
    color: theme.text,
    fontSize: "16px",
    backgroundColor: theme.background,
    borderRadius: "12px",
    border: `2px dashed ${theme.border}`,
  },
  helpText: {
    fontSize: "14px",
    color: theme.text,
    marginTop: "12px",
    fontStyle: "italic",
  },

  levelHeader: {
    margin: "0 0 12px 0",
    fontSize: "14px",
    fontWeight: "600",
    color: theme.text,
  },
  levelHeaderSelected: {
    margin: "0 0 12px 0",
    fontSize: "14px",
    fontWeight: "600",
    color: theme.success,
  },
  featureContainer: {
    marginBottom: "16px",
    backgroundColor: theme.surface,
  },
  singleFeature: {
    marginBottom: "12px",
    padding: "12px",
    backgroundColor: theme.surface,
    borderRadius: "6px",
    border: `2px solid ${theme.border}`,
  },
  singleFeatureSelected: {
    marginBottom: "12px",
    padding: "12px",
    backgroundColor: theme.success + "10",
    borderRadius: "6px",
    border: `2px solid ${theme.success}40`,
  },
  choiceContainer: {
    marginBottom: "12px",
    padding: "12px",
    backgroundColor: theme.surface,
    borderRadius: "6px",
    border: `2px solid ${theme.border}`,
    transition: "all 0.2s ease",
  },
  choiceContainerSelected: {
    marginBottom: "12px",
    padding: "12px",
    backgroundColor: theme.success + "10",
    borderRadius: "6px",
    border: `2px solid ${theme.success}`,
    transition: "all 0.2s ease",
  },
  choiceContainerSelectedOption: {
    marginBottom: "12px",
    padding: "12px",
    backgroundColor: theme.success + "20",
    borderRadius: "6px",
    border: `2px solid ${theme.success}`,
    transition: "all 0.2s ease",
  },
  featureName: {
    fontSize: "13px",
    color: theme.primary,
    display: "block",
    marginBottom: "4px",
    fontWeight: "600",
  },
  featureNameSelected: {
    fontSize: "13px",
    color: theme.success,
    display: "block",
    marginBottom: "4px",
    fontWeight: "600",
  },
  featureDescription: {
    margin: 0,
    fontSize: "12px",
    color: theme.text,
    lineHeight: "1.4",
  },
  featureDescriptionSelected: {
    margin: 0,
    fontSize: "12px",
    color: theme.text,
    lineHeight: "1.4",
  },
  choiceLabel: {
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
    cursor: "pointer",
  },
  choiceLabelDisabled: {
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
    cursor: "not-allowed",
  },
  radioButton: {
    marginTop: "2px",
    accentColor: theme.success,
    cursor: "pointer",
    width: "16px",
    height: "16px",
  },
  radioButtonDisabled: {
    marginTop: "2px",
    accentColor: theme.success,
    cursor: "not-allowed",
    width: "16px",
    height: "16px",
  },
  choiceStatus: {
    color: theme.text,
    fontSize: "12px",
    fontWeight: "normal",
    marginLeft: "8px",
  },
  choiceStatusSelected: {
    fontSize: "12px",
    fontWeight: "normal",
    marginLeft: "8px",
  },
  choiceStatusRequired: {
    color: theme.warning,
    fontSize: "12px",
    fontWeight: "normal",
    marginLeft: "8px",
  },
  choiceInfo: {
    marginBottom: "12px",
    fontSize: "12px",
    color: theme.text,
    fontStyle: "italic",
  },
  lockedFeature: {
    marginBottom: "12px",
    opacity: 0.6,
  },
  lockedContainer: {
    padding: "8px 12px",
    backgroundColor: theme.surface,
    borderRadius: "4px",
    border: `1px solid ${theme.border}`,
    fontSize: "12px",
    color: theme.text,
    fontStyle: "italic",
  },
  summary: {
    padding: "12px",
    borderRadius: "6px",
    borderLeft: `4px solid ${theme.primary}`,
  },
  summarySelected: {
    padding: "12px",
    backgroundColor: theme.success + "10",
    borderRadius: "6px",
    borderLeft: `4px solid ${theme.success}`,
  },
  summaryTitle: {
    fontSize: "12px",
    color: theme.text,
    display: "block",
    marginBottom: "4px",
    fontWeight: "600",
  },
  summaryTitleSelected: {
    fontSize: "12px",
    color: theme.success,
    display: "block",
    marginBottom: "4px",
    fontWeight: "600",
  },
  summaryText: {
    margin: 0,
    fontSize: "12px",
    color: theme.text,
    fontStyle: "italic",
    lineHeight: "1.4",
  },
  warningContainer: {
    fontSize: "14px",
    marginTop: "12px",
    fontStyle: "italic",
    color: theme.warning,
    backgroundColor: theme.warning + "20",
    padding: "8px 12px",
    borderRadius: "4px",
    border: `1px solid ${theme.warning}40`,
  },
  availableChoicesIndicator: {
    fontSize: "12px",
    color: theme.textSecondary,
    marginLeft: "4px",
  },
  featCard: {
    backgroundColor: theme.background,
    border: `2px solid ${theme.border}`,
    marginBottom: "12px",
    borderRadius: "12px",
    padding: "16px",
    transition: "all 0.2s ease",
  },

  featCardSelected: {
    backgroundColor: theme.background,
    border: `2px solid ${theme.primary}`,
    borderRadius: "12px",
    boxShadow: `0 0 0 1px ${theme.primary}20`,
  },

  featName: {
    color: theme.text,
  },

  featNameSelected: {
    color: theme.primary,
    fontWeight: "600",
  },

  featPreview: {
    fontSize: "14px",
    color: theme.textSecondary,
    lineHeight: "1.4",
    fontStyle: "italic",
  },

  featPreviewSelected: {
    fontSize: "14px",
    color: theme.text,
    lineHeight: "1.4",
    fontStyle: "italic",
  },

  featDescription: {
    marginTop: "12px",
    fontSize: "14px",
    color: theme.text,
    lineHeight: "1.5",
    padding: "12px",
    backgroundColor: theme.background,
    borderRadius: "8px",
    border: `1px solid ${theme.border}`,
  },
  featDescriptionSelected: {
    marginTop: "12px",
    fontSize: "14px",
    color: theme.primary,
    lineHeight: "1.5",
    padding: "12px",
    backgroundColor: theme.background,
    borderRadius: "8px",
    border: `1px solid ${theme.primary}`,
    boxShadow: `0 0 0 1px ${theme.primary}20`,
  },
  modifierPillsContainer: {
    backgroundColor: theme.background,
    border: `1px solid ${theme.primary}`,
    borderRadius: "8px",
    padding: "12px",
    marginBottom: "16px",
  },
  pillsLabel: {
    fontSize: "12px",
    fontWeight: "600",
    color: "#3b82f6",
    marginBottom: "8px",
  },
  pillsRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
  },
  modifierPill: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    backgroundColor: "#3b82f6",
    color: "white",
    padding: "4px 8px",
    borderRadius: "12px",
    fontSize: "11px",
    fontWeight: "600",
    cursor: "help",
  },
  initiativePill: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    backgroundColor: "#f59e0b",
    color: "white",
    padding: "4px 8px",
    borderRadius: "12px",
    fontSize: "11px",
    fontWeight: "600",
    cursor: "help",
  },
  pillAbility: {
    opacity: 0.9,
  },
  pillModifier: {
    fontWeight: "bold",
  },
  abilityChange: {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    padding: "1px 4px",
    borderRadius: "4px",
    fontSize: "9px",
  },
});

export const createInventoryStyles = (theme) => ({
  container: {
    maxWidth: "1800px",
    margin: "0 auto",
    padding: "20px",
    backgroundColor: theme.background,
    minHeight: "100vh",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  mainLayout: {
    display: "grid",
    gridTemplateColumns: "350px 1fr",
    gap: "24px",
    maxWidth: "1600px",
    margin: "0 auto",
  },
  bankContainer: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    padding: "20px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    height: "fit-content",
    position: "sticky",
    top: "20px",
  },
  inventorySection: {
    minWidth: 0,
  },
  header: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    padding: "24px",
    marginBottom: "24px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  title: {
    fontSize: "28px",
    fontWeight: "bold",
    color: theme.text,
    margin: "0 0 8px 0",
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  subtitle: {
    fontSize: "16px",
    color: theme.textSecondary,
    margin: 0,
  },
  errorMessage: {
    backgroundColor: (theme.error || "#EF4444") + "20",
    border: `1px solid ${theme.error || "#EF4444"}`,
    color: theme.error || "#EF4444",
    padding: "12px",
    borderRadius: "8px",
    marginBottom: "16px",
    fontSize: "14px",
  },
  loadingMessage: {
    backgroundColor: (theme.primary || "#6366F1") + "20",
    border: `1px solid ${theme.primary || "#6366F1"}`,
    color: theme.primary || "#6366F1",
    padding: "12px",
    borderRadius: "8px",
    marginBottom: "16px",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  controls: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    marginBottom: "24px",
    flexWrap: "wrap",
  },
  addButton: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "12px 20px",
    backgroundColor: theme.primary,
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    fontFamily: "inherit",
  },
  searchContainer: {
    position: "relative",
    flex: "1",
    minWidth: "250px",
  },
  searchInput: {
    width: "100%",
    paddingLeft: "40px",
    paddingRight: "16px",
    paddingTop: "12px",
    paddingBottom: "12px",
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    backgroundColor: theme.surface,
    color: theme.text,
    fontSize: "16px",
    fontFamily: "inherit",
  },
  searchIcon: {
    position: "absolute",
    left: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    color: theme.textSecondary,
  },
  formCard: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    padding: "24px",
    marginBottom: "24px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  formTitle: {
    fontSize: "20px",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "20px",
    margin: "0 0 20px 0",
  },
  formGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "16px",
    marginBottom: "16px",
  },
  formField: {
    display: "flex",
    flexDirection: "column",
  },
  formFieldFull: {
    gridColumn: "1 / -1",
  },
  checkboxField: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    gridColumn: "1 / -1",
    marginTop: "8px",
  },
  label: {
    fontSize: "14px",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "8px",
  },
  checkboxLabel: {
    fontSize: "14px",
    fontWeight: "500",
    color: theme.text,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  input: {
    padding: "12px",
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    backgroundColor: theme.surface,
    color: theme.text,
    fontSize: "16px",
    fontFamily: "inherit",
  },
  checkbox: {
    width: "18px",
    height: "18px",
    accentColor: theme.primary,
    cursor: "pointer",
  },
  select: {
    padding: "12px",
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    backgroundColor: theme.surface,
    color: theme.text,
    fontSize: "16px",
    fontFamily: "inherit",
  },
  textarea: {
    padding: "12px",
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    backgroundColor: theme.surface,
    color: theme.text,
    fontSize: "16px",
    height: "80px",
    resize: "vertical",
    fontFamily: "inherit",
  },
  formActions: {
    display: "flex",
    gap: "12px",
  },
  saveButton: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "12px 24px",
    backgroundColor: theme.success || "#10B981",
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    flex: "1",
    justifyContent: "center",
    fontFamily: "inherit",
  },
  cancelButton: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "12px 24px",
    backgroundColor: theme.textSecondary,
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    fontFamily: "inherit",
  },
  itemsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
    gap: "16px",
  },
  itemCard: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    padding: "20px",
    border: `2px solid ${theme.border}`,
    transition: "all 0.2s ease",
    position: "relative",
  },
  itemHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "12px",
  },
  itemName: {
    fontSize: "18px",
    fontWeight: "600",
    color: theme.text,
    margin: "0 0 4px 0",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexWrap: "wrap",
  },
  quantityBadge: {
    fontSize: "12px",
    fontWeight: "600",
    padding: "4px 8px",
    backgroundColor: theme.background,
    color: theme.text,
    borderRadius: "12px",
    border: `1px solid ${theme.border}`,
  },
  attunementBadge: {
    fontSize: "12px",
    fontWeight: "600",
    padding: "4px 8px",
    backgroundColor: theme.warning || "#F59E0B",
    color: "white",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  itemActions: {
    display: "flex",
    gap: "8px",
  },
  actionButton: {
    padding: "8px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.2s ease",
  },
  editButton: {
    backgroundColor: theme.accent || "#3B82F6",
    color: "white",
  },
  deleteButton: {
    backgroundColor: theme.error || "#EF4444",
    color: "white",
  },
  itemDescription: {
    fontSize: "14px",
    color: theme.textSecondary,
    marginBottom: "12px",
    lineHeight: "1.4",
  },
  itemMeta: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "14px",
    color: theme.text,
    gap: "8px",
    flexWrap: "wrap",
  },
  emptyState: {
    textAlign: "center",
    padding: "60px 20px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
  },
  emptyIcon: {
    marginBottom: "16px",
    opacity: 0.5,
  },
  emptyText: {
    fontSize: "18px",
    color: theme.textSecondary,
    margin: 0,
  },
  categoryHeader: {
    fontSize: "18px",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "16px",
    padding: "12px 16px",
    backgroundColor: theme.surface,
    borderRadius: "8px",
    border: `1px solid ${theme.border}`,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  categoryStats: {
    fontSize: "14px",
    color: theme.textSecondary,
    fontWeight: "normal",
  },
  statsCard: {
    backgroundColor: theme.surface,
    padding: "16px",
    borderRadius: "8px",
    border: `1px solid ${theme.border}`,
    marginBottom: "16px",
  },
  statsRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "14px",
    color: theme.text,
    marginBottom: "8px",
  },
  statsRowLast: {
    marginBottom: 0,
  },
});

export const createCharacterNotesStyles = (theme) => ({
  container: {
    margin: "0 auto",
    padding: "20px",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
    padding: "20px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
  },
  headerContent: {
    display: "flex",
    flexDirection: "column",
  },
  title: {
    margin: "0 0 8px 0",
    fontSize: "28px",
    color: theme.text,
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  subtitle: {
    margin: "0",
    color: theme.text,
    fontSize: "16px",
  },
  headerActions: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
  },
  newEntryButton: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "12px 20px",
    backgroundColor: theme.primary,
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },

  noCharacterContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "60px 20px",
    backgroundColor: "#fef2f2",
    border: "2px solid #fecaca",
    borderRadius: "12px",
    margin: "20px",
    maxWidth: "600px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  noCharacterIcon: {
    marginBottom: "16px",
  },
  noCharacterTitle: {
    color: theme.text,
    margin: "0 0 8px 0",
    fontSize: "24px",
  },
  noCharacterText: {
    color: theme.text,
    margin: "0",
    textAlign: "center",
  },
  newEntryForm: {
    backgroundColor: theme.surface,
    padding: "20px",
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    marginBottom: "20px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
  },
  newEntryTitle: {
    margin: "0 0 12px 0",
    fontSize: "18px",
    color: theme.text,
  },
  newEntryInput: {
    width: "100%",
    padding: "12px",
    border: `1px solid ${theme.border}`,
    borderRadius: "8px",
    fontSize: "16px",
    outline: "none",
    backgroundColor: theme.background,
    color: theme.text,
    marginBottom: "16px",
  },
  templateButtons: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
    marginBottom: "16px",
  },
  templateButton: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    padding: "8px 12px",
    backgroundColor: theme.background,
    border: `1px solid ${theme.border}`,
    borderRadius: "6px",
    fontSize: "14px",
    cursor: "pointer",
    color: theme.text,
    transition: "all 0.2s ease",
  },
  formActions: {
    display: "flex",
    gap: "8px",
  },
  cancelButton: {
    padding: "8px 16px",
    backgroundColor: theme.background,
    border: `1px solid ${theme.border}`,
    borderRadius: "6px",
    cursor: "pointer",
    color: theme.text,
  },
  editForm: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
    overflow: "hidden",
  },
  editHeader: {
    padding: "16px 20px",
    borderBottom: `1px solid ${theme.border}`,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  editTitleInput: {
    flex: 1,
    padding: "8px 12px",
    border: `1px solid ${theme.border}`,
    borderRadius: "6px",
    fontSize: "18px",
    fontWeight: "600",
    marginRight: "12px",
    backgroundColor: theme.background,
    color: theme.text,
  },
  editActions: {
    display: "flex",
    gap: "8px",
  },
  saveButton: {
    padding: "8px 16px",
    backgroundColor: theme.success + "20",
    border: `1px solid ${theme.success}`,
    borderRadius: "6px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    color: theme.success,
    fontSize: "14px",
    fontWeight: "600",
    gap: "6px",
  },
  editCancelButton: {
    padding: "8px 16px",
    backgroundColor: theme.background,
    border: `1px solid ${theme.border}`,
    borderRadius: "6px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
    fontWeight: "600",
    gap: "6px",
    color: theme.text,
  },
  templateSection: {
    padding: "16px 20px",
    borderBottom: `1px solid ${theme.border}`,
    backgroundColor: theme.background,
  },
  templateSectionTitle: {
    margin: "0 0 12px 0",
    fontSize: "14px",
    color: theme.text,
    fontWeight: "600",
  },
  editorContainer: {
    padding: "20px",
  },
  editorLoading: {
    height: "500px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.background,
    borderRadius: "8px",
    color: theme.textSecondary,
  },
  entriesGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(400px, 1fr))",
    gap: "20px",
  },
  entryCard: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
    overflow: "hidden",
    transition: "all 0.2s ease",
  },
  entryHeader: {
    padding: "16px 20px",
    borderBottom: `1px solid ${theme.border}`,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  entryTitleSection: {
    flex: 1,
  },
  entryTitle: {
    margin: "0 0 4px 0",
    fontSize: "18px",
    color: theme.text,
    fontWeight: "600",
  },
  entryDate: {
    margin: "0",
    fontSize: "12px",
    color: theme.text,
  },
  entryActions: {
    display: "flex",
    gap: "8px",
    marginLeft: "12px",
  },
  editEntryButton: {
    padding: "6px",
    backgroundColor: theme.secondary,
    border: `1px solid ${theme.border}`,
    borderRadius: "4px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    color: theme.text,
    transition: "all 0.2s ease",
  },
  deleteEntryButton: {
    padding: "6px",
    backgroundColor: theme.warning,
    border: "1px solid #fecaca",
    borderRadius: "4px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    color: theme.text,
    transition: "all 0.2s ease",
  },
  duplicateEntryButton: {
    padding: "6px",
    backgroundColor: theme.primary,
    border: `1px solid #457880`,
    borderRadius: "4px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    color: theme.text,
    transition: "all 0.2s ease",
  },
  entryContent: {
    padding: "20px",
  },

  loadingContainer: {
    padding: "60px 20px",
    textAlign: "center",
    color: theme.textSecondary,
    fontSize: "16px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
  },
  emptyContainer: {
    padding: "60px 20px",
    textAlign: "center",
    color: theme.textSecondary,
    fontSize: "16px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
  },

  importExportSection: {
    backgroundColor: theme.surface,
    padding: "16px 20px",
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    marginTop: "20px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
  },
  importExportActions: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
  },
  exportButton: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    padding: "8px 12px",
    backgroundColor: theme.success + "20",
    border: `1px solid ${theme.success}`,
    borderRadius: "6px",
    fontSize: "14px",
    cursor: "pointer",
    color: theme.success,
  },
  importLabel: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    padding: "8px 12px",
    backgroundColor: theme.primary + "20",
    border: `1px solid ${theme.primary}`,
    borderRadius: "6px",
    fontSize: "14px",
    cursor: "pointer",
    color: theme.primary,
  },
  hiddenFileInput: {
    display: "none",
  },

  templateButtonHover: {
    backgroundColor: theme.primary + "10",
    borderColor: theme.primary,
  },
  editEntryButtonHover: {
    backgroundColor: theme.primary + "20",
    borderColor: theme.primary,
  },
  deleteEntryButtonHover: {
    backgroundColor: "#fee2e2",
    borderColor: "#dc2626",
  },
  newEntryButtonHover: {
    backgroundColor: theme.secondary,
    transform: "translateY(-1px)",
    boxShadow: `0 4px 12px ${theme.primary}40`,
  },
});

export const createCharacterGalleryStyles = (theme) => ({
  searchContainer: {
    marginBottom: "24px",
    padding: "20px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
  },
  searchInputContainer: {
    position: "relative",
    maxWidth: "500px",
    margin: "0 auto",
  },
  searchInput: {
    width: "100%",
    padding: "12px 16px 12px 44px",
    fontSize: "16px",
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    backgroundColor: theme.background,
    color: theme.text,
    outline: "none",
    transition: "border-color 0.2s ease",
  },
  searchIcon: {
    position: "absolute",
    left: "14px",
    top: "50%",
    transform: "translateY(-50%)",
    color: theme.textSecondary,
  },
  clearButton: {
    position: "absolute",
    right: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    padding: "4px",
    backgroundColor: "transparent",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    color: theme.textSecondary,
  },
  searchResults: {
    marginBottom: "32px",
  },
  searchResultsHeader: {
    padding: "16px 24px",
    backgroundColor: theme.primary + "10",
    borderRadius: "12px 12px 0 0",
    border: `2px solid ${theme.primary}`,
    borderBottom: "none",
  },
  searchResultsTitle: {
    fontSize: "20px",
    fontWeight: "600",
    color: theme.text,
    margin: "0 0 4px 0",
  },
  searchResultsCount: {
    fontSize: "14px",
    color: theme.textSecondary,
    margin: 0,
  },
  searchResultsContent: {
    padding: "20px",
    backgroundColor: theme.surface,
    borderRadius: "0 0 12px 12px",
    border: `2px solid ${theme.primary}`,
    borderTop: "none",
  },
  noResults: {
    textAlign: "center",
    padding: "40px 20px",
    color: theme.textSecondary,
  },
  container: {
    margin: "0 auto",
    padding: "20px",
    backgroundColor: theme.background,
    minHeight: "100vh",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "24px",
    padding: "24px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  headerLeft: {
    display: "flex",
    alignItems: "flex-start",
    gap: "16px",
  },
  title: {
    fontSize: "28px",
    fontWeight: "bold",
    color: theme.text,
    margin: "0 0 8px 0",
  },
  subtitle: {
    fontSize: "16px",
    color: theme.textSecondary,
    margin: 0,
    lineHeight: "1.5",
  },
  headerRight: {
    display: "flex",
    alignItems: "center",
  },
  toggleAllButton: {
    padding: "12px 20px",
    backgroundColor: theme.primary,
    color: theme.surface,
    border: "none",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  statsBar: {
    display: "flex",
    justifyContent: "center",
    gap: "32px",
    marginBottom: "24px",
    padding: "16px",
    backgroundColor: theme.surface,
    borderRadius: "8px",
    border: `1px solid ${theme.border}`,
  },
  statItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    fontWeight: "500",
    color: theme.text,
  },
  schoolContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  schoolSection: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    overflow: "hidden",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  },
  schoolHeader: {
    width: "100%",
    padding: "20px",
    border: "none",
    background: "none",
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    transition: "all 0.2s ease",
    borderBottom: `1px solid ${theme.border}`,
  },
  schoolHeaderLeft: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  schoolTitle: {
    fontSize: "24px",
    fontWeight: "bold",
    color: theme.text,
    margin: 0,
  },
  schoolCount: {
    fontSize: "14px",
    color: theme.textSecondary,
    fontWeight: "normal",
  },
  schoolHeaderRight: {
    display: "flex",
    alignItems: "center",
  },
  schoolContent: {
    padding: "0 0 20px 0",
  },
  typeSection: {
    marginBottom: "12px",
  },
  typeHeader: {
    width: "calc(100% - 40px)",
    padding: "16px",
    border: `1px solid ${theme.border}`,
    borderRadius: "8px",
    background: "none",
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    transition: "all 0.2s ease",
    margin: "0 20px",
  },
  typeHeaderLeft: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  typeTitle: {
    fontSize: "18px",
    fontWeight: "600",
    color: theme.text,
    margin: 0,
  },
  characterCount: {
    fontSize: "12px",
    color: theme.textSecondary,
    fontWeight: "normal",
  },
  typeHeaderRight: {
    display: "flex",
    alignItems: "center",
  },
  charactersGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
    gap: "16px",
    padding: "16px 20px",
  },
  characterCard: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `1px solid ${theme.border}`,
    overflow: "hidden",
    transition: "all 0.2s ease",
    cursor: "pointer",
  },
  characterCardHover: {
    transform: "translateY(-4px)",
    boxShadow: "0 8px 25px rgba(0, 0, 0, 0.15)",
    borderColor: theme.primary,
  },
  imageContainer: {
    position: "relative",
    height: "300px",
    width: "300px",
    overflow: "hidden",
  },
  characterImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  imagePlaceholder: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.background,
    color: theme.textSecondary,
  },
  placeholderText: {
    fontSize: "12px",
    marginTop: "8px",
  },
  characterInfo: {
    padding: "16px",
  },
  characterName: {
    fontSize: "16px",
    fontWeight: "600",
    color: theme.text,
    margin: "0 0 8px 0",
    lineHeight: "1.3",
  },
});

export const createDowntimeStyles = (theme) => ({
  activitiesContainer: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    padding: "24px",
    marginBottom: "24px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  },
  activityCard: {
    backgroundColor: theme.background,
    borderRadius: "12px",
    padding: "20px",
    marginBottom: "20px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
  },
  activityHeader: {
    marginBottom: "16px",
    paddingBottom: "12px",
    borderBottom: `2px solid ${theme.border}`,
  },
  activityTitle: {
    fontSize: "18px",
    fontWeight: "600",
    color: theme.text,
    margin: "0",
  },
  activityContent: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  activitySection: {
    // display: "flex",
    backgroundColor: theme.surface,
    borderRadius: "8px",
    padding: "16px",
    border: `1px solid ${theme.border}`,
  },
  rollSection: {
    backgroundColor: theme.surface,
    borderRadius: "8px",
    padding: "16px",
    border: `1px solid ${theme.border}`,
  },
  rollSectionTitle: {
    fontSize: "14px",
    fontWeight: "600",
    color: theme.primary,
    marginBottom: "12px",
    margin: "0 0 12px 0",
  },
  selectedRollArea: {
    display: "flex",
    gap: "16px",
    marginBottom: "12px",
  },
  notesGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  assignedDiceContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    width: "70px",
    marginBottom: "12px",
  },
  assignedDiceTile: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
    padding: "12px",
    backgroundColor: theme.primary + "20",
    border: `2px solid ${theme.primary}`,
    borderRadius: "8px",
    transition: "all 0.2s ease",
  },
  diceDisplay: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "4px",
    width: "24px",
    height: "32px",
  },
  diceValue: {
    fontSize: "24px",
    fontWeight: "bold",
    color: theme.primary,
  },
  diceLabel: {
    fontSize: "12px",
    color: theme.textSecondary,
    fontWeight: "500",
  },
  removeDiceButton: {
    padding: "4px 8px",
    backgroundColor: "#ef4444",
    color: "white",
    border: "none",
    borderRadius: "4px",
    fontSize: "12px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  successSection: {
    backgroundColor: theme.surface,
    borderRadius: "8px",
    padding: "16px",
    border: `1px solid ${theme.border}`,
  },
  successHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "12px",
  },
  adminOnlyBadge: {
    padding: "2px 8px",
    backgroundColor: "#ef4444",
    color: "white",
    borderRadius: "12px",
    fontSize: "10px",
    fontWeight: "600",
    textTransform: "uppercase",
  },
  successGrid: {
    display: "flex",
    gap: "8px",
    marginBottom: "12px",
  },
  successButton: {
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    border: "2px solid",
    backgroundColor: "transparent",
    color: theme.text,
    fontSize: "12px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  successText: {
    fontSize: "14px",
    color: theme.textSecondary,
    fontWeight: "500",
    margin: "0",
  },
  adminCompletedNotice: {
    backgroundColor: `#8b5cf6${"20"}`,
    color: "#8b5cf6",
    padding: "16px",
    borderRadius: "8px",
    border: `2px solid #8b5cf6`,
    marginBottom: "20px",
    textAlign: "center",
  },
  completedNotice: {
    backgroundColor: `#8b5cf6${"20"}`,
    color: "#8b5cf6",
    padding: "12px",
    borderRadius: "6px",
    textAlign: "center",
    fontSize: "14px",
    fontWeight: "600",
  },
  container: {
    margin: "0 auto",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    fontSize: "14px",
    backgroundColor: theme.background,
    color: theme.text,
    minHeight: "100vh",
    maxWidth: "1200px",
  },
  loadingOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  loadingSpinner: {
    backgroundColor: theme.surface,
    padding: "20px 40px",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "bold",
    color: theme.text,
  },
  emptyState: {
    textAlign: "center",
    padding: "60px 20px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
  },
  formContainer: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    padding: "24px",
    marginBottom: "24px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  },
  characterInfo: {
    marginBottom: "24px",
    textAlign: "center",
  },
  title: {
    fontSize: "28px",
    fontWeight: "bold",
    color: theme.text,
    marginBottom: "8px",
  },
  characterDetails: {
    display: "flex",
    justifyContent: "center",
    gap: "24px",
    marginTop: "16px",
    fontSize: "16px",
    color: theme.textSecondary,
  },
  selectionSection: {
    backgroundColor: theme.background,
    padding: "20px",
    borderRadius: "8px",
    marginBottom: "24px",
    border: `1px solid ${theme.border}`,
  },
  selectionRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "20px",
  },
  selectionGroup: {
    display: "flex",
    flexDirection: "column",
    padding: "4px",
    gap: "8px",
  },
  magicSchoolSection: {
    backgroundColor: theme.background,
    padding: "20px",
    borderRadius: "8px",
    marginBottom: "24px",
    border: `1px solid ${theme.border}`,
  },
  sectionHeader: {
    marginBottom: "16px",
  },
  subtitle: {
    fontSize: "14px",
    color: theme.textSecondary,
    margin: "4px 0 0 0",
  },
  magicSchoolGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "12px",
  },
  magicSchoolChoice: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px",
    cursor: "pointer",
  },
  checkboxText: {
    fontSize: "14px",
    color: theme.text,
  },
  instructionsSection: {
    backgroundColor: theme.background,
    padding: "20px",
    borderRadius: "8px",
    marginBottom: "24px",
    border: `1px solid ${theme.border}`,
  },
  instructions: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  instructionItem: {
    padding: "12px",
    backgroundColor: theme.surface,
    borderRadius: "6px",
    borderLeft: `4px solid ${theme.primary}`,
  },
  guidelinesSection: {
    backgroundColor: theme.background,
    padding: "20px",
    borderRadius: "8px",
    marginBottom: "24px",
    border: `1px solid ${theme.border}`,
  },
  guidelines: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  guidelineCategory: {
    backgroundColor: theme.surface,
    padding: "16px",
    borderRadius: "8px",
    border: `1px solid ${theme.border}`,
  },
  guidelineList: {
    marginLeft: "20px",
    marginTop: "8px",
  },
  diceSection: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    padding: "24px",
    marginBottom: "24px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  },
  diceHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  dicePool: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  diceGrid: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  diceItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "15px",
    borderRadius: "8px",
    textAlign: "center",
    height: "60px",
    width: "60px",
  },
  diceUsage: {
    fontSize: "10px",
    color: theme.textSecondary,
  },
  diceStats: {
    display: "flex",
    justifyContent: "space-around",
    padding: "12px",
    backgroundColor: theme.background,
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "bold",
  },
  emptyDice: {
    textAlign: "center",
    padding: "40px 20px",
    color: theme.textSecondary,
    backgroundColor: theme.background,
    borderRadius: "8px",
    border: `2px dashed ${theme.border}`,
  },
  activityRow: {
    display: "grid",
    gridTemplateColumns: "120px 1fr",
    gap: "12px",
    alignItems: "center",
    marginBottom: "12px",
  },
  rollHeader: {
    fontSize: "16px",
    fontWeight: "bold",
    marginBottom: "12px",
    color: theme.primary,
  },
  rollRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "16px",
    marginBottom: "12px",
  },
  diceAssignment: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  assignedDice: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px 12px",
    backgroundColor: theme.background,
    borderRadius: "4px",
    border: `1px solid ${theme.border}`,
  },
  modifierSelection: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  secondRoll: {
    marginTop: "16px",
    paddingTop: "16px",
    borderTop: `1px solid ${theme.border}`,
  },
  secondRollHeader: {
    fontSize: "14px",
    fontWeight: "bold",
    marginBottom: "8px",
    color: theme.textSecondary,
  },

  npcSection: {
    backgroundColor: theme.surface,
    padding: "16px",
    borderRadius: "6px",
    marginTop: "16px",
    border: `1px solid ${theme.border}`,
  },
  npcHeader: {
    fontSize: "16px",
    fontWeight: "bold",
    marginBottom: "12px",
    color: theme.secondary || theme.primary,
  },
  npcRow: {
    display: "grid",
    gridTemplateColumns: "120px 1fr",
    gap: "12px",
    alignItems: "center",
    marginBottom: "12px",
  },
  successCheckboxes: {
    display: "flex",
    gap: "8px",
    marginTop: "8px",
  },
  checkboxLabel: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    cursor: "pointer",
  },
  successDots: {
    display: "flex",
    gap: "4px",
    marginTop: "4px",
  },
  successDot: {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    border: `1px solid ${theme.border}`,
  },

  notesSection: {
    marginTop: "16px",
  },
  resultsContainer: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    padding: "24px",
    marginBottom: "24px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  },
  resultsHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  summaryStats: {
    display: "flex",
    gap: "20px",
  },
  stat: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "4px",
  },
  statLabel: {
    fontSize: "12px",
    color: theme.textSecondary,
  },
  statValue: {
    fontSize: "16px",
    fontWeight: "bold",
    color: theme.text,
  },
  noResults: {
    textAlign: "center",
    padding: "40px 20px",
    color: theme.textSecondary,
    backgroundColor: theme.background,
    borderRadius: "8px",
    border: `2px dashed ${theme.border}`,
  },
  resultsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "16px",
  },

  resultCard: {
    backgroundColor: theme.background,
    padding: "16px",
    borderRadius: "8px",
    border: `1px solid ${theme.border}`,
  },
  resultHeader: {
    marginBottom: "12px",
  },
  activityName: {
    fontSize: "14px",
    color: theme.textSecondary,
    margin: "4px 0 0 0",
  },
  resultDetails: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  rollBreakdown: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    fontSize: "14px",
  },
  diceRoll: {
    fontWeight: "bold",
    color: theme.text,
  },
  modifier: {
    color: theme.textSecondary,
  },
  totalResult: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 12px",
    backgroundColor: theme.surface,
    borderRadius: "6px",
    fontWeight: "bold",
  },
  totalNumber: {
    fontSize: "18px",
    color: theme.text,
  },
  dcInfo: {
    fontSize: "14px",
    color: theme.textSecondary,
  },
  successLevel: {
    fontSize: "14px",
    fontWeight: "bold",
  },
  notes: {
    marginTop: "12px",
    padding: "8px",
    backgroundColor: theme.surface,
    borderRadius: "4px",
    fontSize: "12px",
    color: theme.textSecondary,
  },

  progressSummary: {
    marginTop: "24px",
    padding: "20px",
    backgroundColor: theme.background,
    borderRadius: "8px",
    border: `1px solid ${theme.border}`,
  },
  progressGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "16px",
  },
  progressItem: {
    padding: "12px",
    backgroundColor: theme.surface,
    borderRadius: "6px",
    border: `1px solid ${theme.border}`,
  },
  progressHeader: {
    fontSize: "14px",
    fontWeight: "bold",
    color: theme.primary,
    marginBottom: "4px",
  },
  progressActivity: {
    fontSize: "12px",
    color: theme.text,
    marginBottom: "4px",
  },
  progressNpc: {
    fontSize: "12px",
    color: theme.textSecondary,
    marginBottom: "8px",
  },
  progressSuccesses: {
    fontSize: "12px",
    fontWeight: "bold",
    color: theme.text,
  },

  actionsContainer: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    padding: "24px",
    marginBottom: "24px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  },

  viewModeSelector: {
    display: "flex",
    gap: "8px",
    marginBottom: "20px",
  },
  viewModeButton: {
    padding: "8px 16px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "bold",
    transition: "all 0.2s ease",
  },

  actionButtons: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  buttonGroup: {
    display: "flex",
    gap: "12px",
    flexWrap: "wrap",
  },
  button: {
    padding: "10px 20px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "bold",
    color: "white",
    transition: "all 0.2s ease",
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  removeButton: {
    padding: "4px 8px",
    backgroundColor: "#ef4444",
    color: "white",
    border: "none",
    borderRadius: "4px",
    fontSize: "12px",
    cursor: "pointer",
  },

  submittedStatus: {
    display: "flex",
    alignItems: "center",
  },
  submittedText: {
    color: "#10b981",
    fontWeight: "bold",
  },
  statusInfo: {
    marginTop: "16px",
    padding: "12px",
    backgroundColor: theme.background,
    borderRadius: "6px",
  },
  draftNotice: {
    padding: "8px 12px",
    backgroundColor: "#fef3c7",
    color: "#92400e",
    borderRadius: "4px",
    marginBottom: "8px",
  },
  lastEdited: {
    fontSize: "12px",
    color: theme.textSecondary,
  },

  characterSummary: {
    marginTop: "16px",
    padding: "16px",
    backgroundColor: theme.background,
    borderRadius: "8px",
    border: `1px solid ${theme.border}`,
  },
  summaryGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
    gap: "8px",
    marginTop: "8px",
    fontSize: "14px",
  },

  label: {
    fontSize: "14px",
    fontWeight: "bold",
    color: theme.text,
    marginBottom: "4px",
    display: "block",
  },
  select: {
    width: "100%",
    padding: "8px 12px",
    border: `1px solid ${theme.border}`,
    borderRadius: "4px",
    backgroundColor: theme.surface,
    color: theme.text,
    fontSize: "14px",
  },
  input: {
    width: "100%",
    padding: "8px 12px",
    border: `1px solid ${theme.border}`,
    borderRadius: "4px",
    backgroundColor: theme.surface,
    color: theme.text,
    fontSize: "14px",
  },
  textarea: {
    width: "100%",
    padding: "8px 12px",
    border: `1px solid ${theme.border}`,
    borderRadius: "4px",
    backgroundColor: theme.surface,
    color: theme.text,
    fontSize: "14px",
    minHeight: "60px",
    resize: "vertical",
  },
  checkbox: {
    width: "16px",
    height: "16px",
    accentColor: theme.primary,
  },

  sheet: {
    backgroundColor: theme.surface,
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  headerSection: {
    display: "grid",
    gridTemplateColumns: "2fr 2fr",
    borderBottom: `2px solid ${theme.border}`,
  },
  nameSection: {
    padding: "12px",
    borderRight: `2px solid ${theme.border}`,
  },
  gradesSection: {
    padding: "12px",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "14px",
    backgroundColor: theme.primary + "20",
    borderBottom: `2px solid ${theme.border}`,
    color: theme.text,
  },
  yearSemesterSection: {
    display: "grid",
    gridTemplateColumns: "2fr 1fr",
    borderBottom: `2px solid ${theme.border}`,
  },
  typeSection: {
    padding: "12px",
  },
  semesterSection: {
    padding: "12px",
  },
  subjectsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    borderBottom: `2px solid ${theme.border}`,
  },
  subjectColumn: {
    borderRight: `2px solid ${theme.border}`,
    "&:last-child": {
      borderRight: "none",
    },
  },
  subjectItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 12px",
    borderBottom: `1px solid ${theme.border}`,
  },
  activitiesSection: {
    borderBottom: `2px solid ${theme.border}`,
  },
  relationshipRow: {
    display: "grid",
    gridTemplateColumns: "50px 1fr auto auto",
    alignItems: "center",
    padding: "12px",
    borderBottom: `1px solid ${theme.border}`,
    gap: "8px",
    backgroundColor: theme.background,
  },
  relationshipInput: {
    border: `1px solid ${theme.border}`,
    borderRadius: "4px",
    padding: "6px 8px",
    backgroundColor: theme.surface,
    color: theme.text,
  },
  gradeInput: {
    width: "60px",
    padding: "4px 6px",
    border: `1px solid ${theme.border}`,
    borderRadius: "4px",
    backgroundColor: theme.surface,
    color: theme.text,
    textAlign: "center",
  },
});

export const createRecipesStyles = (theme) => ({
  container: {
    maxWidth: "1400px",
    margin: "0 auto",
    padding: "20px",
    backgroundColor: theme.background,
    minHeight: "100vh",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  header: {
    textAlign: "center",
    marginBottom: "32px",
    padding: "24px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  headerContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "16px",
  },
  headerIcon: {
    color: theme.primary,
  },
  title: {
    fontSize: "32px",
    fontWeight: "bold",
    color: theme.text,
    margin: 0,
  },
  subtitle: {
    fontSize: "16px",
    color: theme.textSecondary,
    margin: "8px 0 0 0",
  },
  content: {
    display: "grid",
    gridTemplateColumns: "1fr 400px",
    gap: "24px",
    alignItems: "start",
  },
  recipeLibrary: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    padding: "20px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  searchAndFilter: {
    display: "flex",
    gap: "16px",
    marginBottom: "16px",
    alignItems: "center",
  },
  searchContainer: {
    position: "relative",
    flex: 1,
  },
  searchIcon: {
    position: "absolute",
    left: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    color: theme.textSecondary,
  },
  searchInput: {
    width: "100%",
    padding: "12px 12px 12px 44px",
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    backgroundColor: theme.background,
    color: theme.text,
    fontSize: "14px",
    outline: "none",
    transition: "border-color 0.2s ease",
  },
  categoryFilter: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  filterIcon: {
    color: theme.textSecondary,
  },
  categorySelect: {
    padding: "12px",
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    backgroundColor: theme.background,
    color: theme.text,
    fontSize: "14px",
    outline: "none",
    cursor: "pointer",
  },
  recipeCount: {
    fontSize: "14px",
    color: theme.textSecondary,
    marginBottom: "16px",
    textAlign: "center",
  },
  recipeGrid: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    maxHeight: "600px",
    overflowY: "auto",
    paddingRight: "8px",
  },
  recipeItem: {
    padding: "16px",
    backgroundColor: theme.background,
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  recipeItemSelected: {
    backgroundColor: theme.primary + "20",
    borderColor: theme.primary,
    transform: "translateY(-2px)",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
  },
  recipeHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "8px",
  },
  recipeName: {
    fontSize: "16px",
    fontWeight: "600",
    color: theme.text,
    margin: 0,
    flex: 1,
  },
  recipeMeta: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    alignItems: "flex-end",
  },
  recipeTime: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    fontSize: "12px",
    color: theme.textSecondary,
    backgroundColor: theme.surface,
    padding: "2px 6px",
    borderRadius: "4px",
  },
  recipeDuration: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    fontSize: "12px",
    color: theme.textSecondary,
    backgroundColor: theme.surface,
    padding: "2px 6px",
    borderRadius: "4px",
  },
  recipeDescription: {
    fontSize: "14px",
    color: theme.textSecondary,
    lineHeight: "1.4",
    margin: 0,
  },
  cookingInterface: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  selectedRecipeCard: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    padding: "20px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  selectedRecipeTitle: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    fontSize: "20px",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "12px",
    margin: 0,
  },
  selectedRecipeDescription: {
    fontSize: "14px",
    color: theme.textSecondary,
    lineHeight: "1.5",
    marginBottom: "16px",
  },
  recipeDetails: {
    backgroundColor: theme.background,
    padding: "12px",
    borderRadius: "8px",
    marginBottom: "16px",
  },
  detailRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "8px",
  },
  detailLabel: {
    fontSize: "14px",
    fontWeight: "500",
    color: theme.textSecondary,
  },
  detailValue: {
    fontSize: "14px",
    fontWeight: "600",
    color: theme.text,
  },
  rollPreview: {
    marginBottom: "20px",
  },
  rollPreviewContent: {
    marginBottom: "12px",
  },
  ingredientSection: {
    marginBottom: "16px",
  },
  sectionTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "12px",
  },
  ingredientControls: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "8px",
  },
  qualityButton: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "4px",
    padding: "12px 8px",
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    backgroundColor: theme.background,
    color: theme.text,
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  qualityButtonActive: {
    backgroundColor: theme.primary + "20",
    borderColor: theme.primary,
    color: theme.primary,
  },
  qualityModifier: {
    fontSize: "12px",
    color: theme.textSecondary,
    fontWeight: "400",
  },
  cookingControls: {
    marginBottom: "20px",
  },
  cookButton: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    padding: "16px",
    backgroundColor: theme.primary,
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  cookButtonDisabled: {
    backgroundColor: theme.textSecondary,
    cursor: "not-allowed",
  },
  spinner: {
    width: "16px",
    height: "16px",
    border: "2px solid transparent",
    borderTop: "2px solid white",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
  qualityEffects: {
    marginBottom: "20px",
  },
  qualityList: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  qualityEffect: {
    padding: "12px",
    backgroundColor: theme.background,
    borderRadius: "8px",
    border: `1px solid ${theme.border}`,
  },
  qualityEffectHeader: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    fontWeight: "600",
    marginBottom: "8px",
  },
  qualityEffectText: {
    fontSize: "13px",
    color: theme.textSecondary,
    lineHeight: "1.4",
    margin: 0,
  },
  qualityFlawed: {
    color: "#EF4444",
  },
  qualityRegular: {
    color: "#6B7280",
  },
  qualityExceptional: {
    color: "#3B82F6",
  },
  qualitySuperior: {
    color: "#8B5CF6",
  },
  lastResultCard: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    padding: "20px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  resultHeader: {
    marginBottom: "16px",
  },
  resultTitle: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "18px",
    fontWeight: "600",
    color: theme.text,
    margin: 0,
  },
  resultContent: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  resultRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  resultLabel: {
    fontSize: "14px",
    fontWeight: "500",
    color: theme.textSecondary,
  },
  resultValue: {
    fontSize: "14px",
    fontWeight: "600",
    color: theme.text,
  },
  diceRoll: {
    fontSize: "14px",
    fontFamily: "monospace",
    color: theme.text,
  },
  totalValue: {
    fontWeight: "700",
    color: theme.primary,
  },
  qualityResult: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    fontSize: "14px",
    fontWeight: "600",
    textTransform: "capitalize",
  },
  resultTimestamp: {
    fontSize: "12px",
    color: theme.textSecondary,
    textAlign: "center",
    fontStyle: "italic",
    marginTop: "8px",
  },
  referenceGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "20px",
    marginTop: "32px",
  },
  card: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    padding: "20px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  cardTitle: {
    fontSize: "18px",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "16px",
    margin: 0,
  },
  referenceTable: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
  },
  referenceTableHeader: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "12px",
    padding: "8px 12px",
    backgroundColor: theme.primary + "20",
    borderRadius: "6px",
    fontSize: "14px",
    fontWeight: "600",
    color: theme.text,
  },
  referenceTableRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "12px",
    padding: "8px 12px",
    borderBottom: `1px solid ${theme.border}`,
    fontSize: "14px",
    color: theme.text,
  },
  referenceTableRowHeader: {
    fontWeight: "600",
    textTransform: "capitalize",
  },
  ingredientEffectsList: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  ingredientEffectRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 12px",
    backgroundColor: theme.background,
    borderRadius: "6px",
    fontSize: "14px",
  },
  ingredientEffectLabel: {
    fontWeight: "600",
    textTransform: "capitalize",
    color: theme.text,
  },
  ingredientEffectValue: {
    fontWeight: "500",
    color: theme.text,
  },
  ingredientEffectHarder: {
    color: "#EF4444",
  },
  ingredientEffectEasier: {
    color: "#10B981",
  },
});

export const getAllStyles = (theme) => ({
  app: createAppStyles(theme),
  characterSheet: createCharacterSheetStyles(theme),
  abilityScores: createAbilityScoresStyles(theme),
  skills: createSkillsStyles(theme),
  characterCreation: createCharacterCreationStyles(theme),
  abilityScorePicker: createAbilityScorePickerStyles(theme),
  spellBook: createSpellBookStyles(theme),
  characterSelector: createCharacterSelectorStyles(theme),
  characterNotes: createCharacterNotesStyles(theme),
  recipes: createRecipesStyles(theme),
  potions: createPotionsStyles(theme),
  feats: createFeatStyles(theme),
});

export {
  createAppStyles as createThemedStyles,
  createCharacterSheetStyles as getCharacterSheetStyles,
  createAbilityScoresStyles as getAbilityScoresStyles,
  createSkillsStyles as getSkillsStyles,
  createCharacterCreationStyles as getStyles,
  createAbilityScorePickerStyles as getAbilityScorePickerStyles,
  createSpellBookStyles as createThemedSpellBookStyles,
  createCharacterSelectorStyles as getCharacterSelectorStyles,
  createCharacterNotesStyles as getCharacterNotesStyles,
  createPotionsStyles as createThemedPotionStyles,
  createFeatStyles as getFeatStyles,
  createInventoryStyles as getInventoryStyles,
  createCharacterGalleryStyles as getCharacterGalleryStyles,
  createDowntimeStyles as getDowntimeStyles,
  createRecipesStyles as getRecipesStyles,
};
